<template>
    <div>
        <nav-bar-main></nav-bar-main>
        <NavBarReport v-if="isBothType"></NavBarReport>

<!--   -->
        <div :class="isBothType ? 'alerts-wrapper' : ''">
          <b-alert
            v-if="plantDetails != null && plantDetails.plant_type == 'basic'"
            show
            variant="warning"
            style="display:inline-block;width:100%"
          >
              <BannerPro/>
          </b-alert>
<!--  -->
          <b-alert
            v-if="plantDetails != null && $store.getters.isProExpired"
            show
            variant="warning"
            style="display:inline-block;width:100%"
          >
              <BannerProExpired/>
          </b-alert>
        </div>

        <!--- Loader per il caricamento pagina o invio dei comandi -->
        <Loader />

        <!-- <ErrorBanner />
        <Loader /> -->

        <div v-if="logbookDetails != null" class="reportImpiantoMainContent animated fadeIn container-fluid">

             <b-row v-if="isPro && !$store.getters.isProExpired" class="mt-4 ml-3 mr-3">

                <!--- Graph Donut Report funzionali, di autonomia, di illuminazione -->
                <b-col v-if="tableDataLogbook.length>0" xl="6" lg="12" class="mt-3">
                    <b-card class="home-widget text-widget bg-secondary radius-card h-100">
                        <b-card-body>

                            <!-- title report-->
                            <b-row class="mt-2 mb-3">

                                <b-col cols="sm-8">
                                    <label for="grafico1-year" class="typo-title mr-2 border mb-3 p-2">
                                        <div class="ml-2 mr-2"><b>{{$t('report_table.title_logbook').toUpperCase()}}</b></div>
                                        <b v-if="this.tipoDispositivo=='emergenza'" class="ml-2 mr-2">{{$t('report_table.title_logbook_emergency').toUpperCase()}}</b>
                                        <b v-else class="ml-2 mr-2">{{$t('report_table.title_logbook_lighting').toUpperCase()}}</b>
                                    </label>
                                </b-col>

                                <!-- download -->
                                <b-col cols="sm-3">
                                    <b-button v-if="tableDataLogbook.length>0" class="download float-right mr-2" @click="createPDF_Snapshot()">
                                      <i class="fas fa fa-1x fa-download mr-2"></i>{{ $t("download") }}
                                    </b-button>
                                </b-col>

                            </b-row>


                            <!-- donut lampade pass/fail alla fine dei test automatici -->
                            <b-row>
                                <b-col sm="5">
                                    <GraficoDonutReport class="d-flex justify-content-center" v-if="graphLampLogbook != null" :graphData="graphLampLogbook" :key="graphKeyLamp"/>
                                    <!-- <grafico-donut-report class="d-flex justify-content-center" v-if="graphLampLogbook != null" :graphData="graphLampLogbook" />  -->
                                </b-col>
                                <b-col sm="7">
                                    <div class="d-flex justify-content-start mt-5">
                                        <i class="fa fa-square mt-1 mr-2" style="color:#29CC96"></i>
                                        <p class="bold-18 mr-1">{{this.numLampReportPass}}</p><p class="text-justify mr-2 ">{{this.$t("graph.report_lamp_pass")}}</p>
                                    </div>
                                    <div class="d-flex justify-content-start">
                                        <i class="fa fa-square mt-1 mr-2" style="color:#F03040"></i>
                                        <p class="bold-18 mr-1">{{this.numLampReportFail}}</p><p class="text-justify mr-2 ">{{this.$t("graph.report_lamp_fail")}}</p>
                                    </div>
                                    <div v-if="this.numLampReportNotExecuted>0" class="d-flex justify-content-start">
                                        <i class="fa fa-square mr-2 mt-1" style="color:#b5b3b3"></i>
                                        <p class="bold-18  mr-1">{{this.numLampReportNotExecuted}}</p><p>{{this.$t("graph.report_lamp_not_executed")}}</p>
                                    </div>
                                   <!-- <div v-if="this.numLampReportFailUvoxy>0" class="d-flex justify-content-start">
                                        <i class="fa fa-square mr-2 mt-1" style="color:#3287a8"></i>
                                        <p class="bold-18  mr-1">{{this.numLampReportFailUvoxy}}</p><p>{{this.$t("graph.report_lamp_fail_uvoxy")}}</p>
                                    </div> -->
                                    <div v-if="this.numLampReportOrphan>0" class="d-flex justify-content-start">
                                        <i class="fa fa-square mr-2 mt-1" style="color:#EE82EE"></i>
                                        <p class="bold-18  mr-1">{{this.numLampReportOrphan}}</p><p>{{this.$t("details_cu_modal.cu_orphan")}}</p>
                                    </div>
                                </b-col>
                            </b-row>


                            <!-- table logbook funzionale e autonomia  -->
                            <b-row class="mt-5">
                                <b-col cols="12">
                                    <b-table
                                      class="datatable-body"
                                      :items="reportCentData"
                                      :fields="[
                                        {key: 'cu_desc', label:this.$t('report_table.central'), sortable:true,'class':'cuCol'},
                                        {key: 'report_date', label:this.$t('graph.report_date'),sortable:true,'class':'dateCol'},
                                        {key: 'report_type', label:this.$t('report_table.log_type'),sortable:true,'class':'typeCol'},
                                        {key: 'status', label:this.$t('report_table.state'),sortable:true,'class': 'statusCol' }
                                      ]"
                                    >
                                        <template #cell(cu_desc)="data">
                                            <strong>{{data.value.split("|")[0]}}</strong><br/>
                                            <span>{{data.value.split("|")[1]}}</span><br/>
                                        </template>
                                        <template #cell(report_date)="data">
                                            <strong>{{data.value>1000000000?dataRep(data.value).data:""}}</strong><br/>
                                            <span>{{ data.value>1000000000?dataRep(data.value).ora:""}}</span><br/>
                                        </template>
                                        <template #cell(report_type)="data">
                                            <span>{{data.value?$t("report_table."+ data.value):""}}</span><br/>
                                        </template>

                                        <template  #cell(status)="data">

                                          <!-- check if functional test PASS but at least one luminaire with autonomy error -->
                                            <div v-if="data.item.report_type=='test_funzionale_automatico'  //if functional test
                                                  && data.value==1        //if functional test PASS && error_batt_test_auto=ON on at least one lamp
                                                  && data.item.log_lamps.some((el) => el.error_batt_test_auto=='ON')">

                                                <i :class="['fa fa-circle ' + ((data.value == 1)?'success': (data.value==-1)?'danger':'default'), 'my-auto']"></i>
                                                <i class="fa fa-exclamation pl-1" style="color: red"></i>
                                                {{$t('report_table.error_auto_in_funct')}}
                                            </div>

                                        <div v-else>

                                                <i :class="['fa fa-circle ' + ((data.value == 1)?'success': (data.value==-1)?'danger':'default'), 'my-auto']"></i>
                                                {{(data.value == 1)?"Test ok" : (data.value == -1) ? $t('report_table.error_found'):$t('report_table.not_executed')}}
                                        </div>

                                        </template>
                                    </b-table>
                                </b-col>
                            </b-row>

                            <!-- select period -->
                            <b-row class="mt-5">

                                <b-col cols="6">
                                <b-form inline class="pb-3">
                                    <label for="grafico1-year" class="typo-subtitle mr-2">
                                        <span class="ml-2 mr-2">{{$t('graph.select_period')}}</span>
                                    </label>
                                    <b-form-select v-model="funct_graph_time" :options="options_funct"  class="typo-subtitle"></b-form-select>
                                </b-form>
                                </b-col>

                            </b-row>

                          </b-card-body>
                    </b-card>
                </b-col>

                <!--- Graph Donut Lampade in errore da Report funzionali, di autonomia e illuminazione -->
                <b-col v-if="tableDataLogbook.length>0" xl="6" lg="12" class="mt-3">
                    <b-card class="home-widget text-widget bg-secondary radius-card h-100">
                        <b-card-body>

                            <!-- title report-->
                            <b-row class="mt-2 mb-3">

                                <b-col cols="sm-8">
                                <b-form inline class="pb-3">
                                    <label for="grafico1-year" class="typo-title mr-2 border mb-3 p-2">
                                        <b class="ml-2 mr-2">{{$t('report_table.title_logbook_errors').toUpperCase()}}</b>
                                    </label>
                                </b-form>
                                </b-col>
                            </b-row>


                            <!-- donut tipologia di errori nelle lampade fail-->
                            <b-row>
                                    <b-col sm="5">
                                        <GraficoDonutReportError class="d-flex justify-content-center" v-if="graphLampsErrorType != null" :graphData="graphLampsErrorType" :key="graphKeyLamp"/>
                                    </b-col>
                                    <!-- array con gli errori
                                    [0-this.numLampReportFail, 1-numHwError, 2-numLedError, 3-numBattShort, 4-numBattFunctError, 5-numBattAutoError, 6-numComError,
                                     7-numUvoxyError, 8-numUnderpowerError, 9-numUndervoltageError , 10.numOverpowerError, 11-numOvervoltageError,
                                     12-numCommRadioLampError, 13-numOrphan, 14-numDaliError, 15-numUnderThresholdError, 16-numProgError, 17-numBusVoltError,
                                     18-numDuplicateError, 19-numLineFuseError] -->
                                    <b-col sm="7 mt-1">
                                        <div v-if="graphLampsErrorType[1]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#8f2710"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[1]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_hardware")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[2]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#8f5a10"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[2]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_led")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[3]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#8f105f"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[3]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_batt_short")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[4]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#db1f18"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[4]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_batt_test_funz")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[5]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#db6d18"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[5]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_batt_test_auto")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[6]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#efb954"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[6]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_com")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[7]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#3287a8"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[7]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_tubo_UV")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[8]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#6d597a"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[8]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_underpower")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[9]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#b56576"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[9]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_undervoltage")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[10]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#723d46"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[10]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_overpower")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[11]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#472d30"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[11]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_overvoltage")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[12]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#000814"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[12]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_comm_radio_lamp")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[13]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#EE62EE"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[13]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_orphan_error")}}</p>
                                        </div>
                            <!-- SICURO -->
                                        <div v-if="graphLampsErrorType[14]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#FFFF33"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[14]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_dali_lamp")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[15]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#FFD700"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[15]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_under_threshold")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[16]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#FFDB58"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[16]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_programming")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[17]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#FFFFCC"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[17]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_bus_voltage")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[18]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#DFFF00"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[18]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_duplicate")}}</p>
                                        </div>
                                        <div v-if="graphLampsErrorType[19]>0" class="d-flex justify-content-start">
                                            <i class="fa fa-square mt-1 mr-2" style="color:#B4C424"></i>
                                            <p class="bold-18 mr-1">{{graphLampsErrorType[19]}}</p><p class="text-justify mr-2 ">{{this.$t("details_lamp.lamp_error_line_fuse")}}</p>
                                        </div>
                                    </b-col>
                                </b-row>

                                <!-- table lampade che presentano un errore  -->
                                <b-row class="mt-5">
                                    <b-col cols="12">
                                        <b-table
                                          class="datatable-body"
                                          :items="tableLampsWithErrors"
                                          :fields="[
                                            {key: 'index', label: ''},
                                            {key: 'id', label: $t('report_pdf.title_id_lamp'), sortable:true,'class':'idCol'},
                                            {key: 'cuName', label: $t('report_table.central'), sortable:true,'class':'cuCol'},
                                            {key: 'report_date', label: $t('graph.report_date'), sortable:true,'class':'dateCol'},
                                            {key: 'report_type', label: $t('report_table.log_type'), sortable:true,'class':'typeCol'},
                                            {key: 'errori', label: $t('details_lamp.lamp_error'), sortable:true,'class': 'errorCol' }
                                          ]"
                                        >
                                        <template #cell(index)="data">
                                            <small>{{ data.index + 1 }}</small>
                                        </template>
                                        <template #cell(id)="data">
                                            <strong>{{ data.value }}</strong>
                                        </template>
                                        <template #cell(cuName)="data">
                                            <strong>{{ data.value.split("|")[0] }}</strong><br/>
                                            <span>{{ data.value.split("|")[1] }}</span><br/>
                                        </template>
                                        <template #cell(report_date)="data">
                                            <strong>{{ data.value.split(" ")[0] }}</strong><br/>
                                            <span>{{ data.value.split(" ")[1] }}</span><br/>
                                        </template>
                                        <template #cell(report_type)="data">
                                            <span>{{ data.value }}</span><br/>
                                        </template>
                                        <!-- <template #cell(status)="data">
                                             <i :class="['fa fa-circle ' + ((data.value == 1)?'success': (data.value==-1)?'danger':'default'), 'my-auto']"></i> {{(data.value == 1)?"Test ok" : (data.value == -1) ? $t('report_table.error_found'):$t('report_table.not_executed')}}
                                        </template> -->
                                        </b-table>
                                    </b-col>
                                </b-row>

                        </b-card-body>
                    </b-card>

                </b-col>

            </b-row>

            <b-row v-else  class="mt-4 ml-3 mr-3">
              <b-col>

                <b-card v-if="!isPro || $store.getters.isProExpired" :title="this.$t('settings.storicData')" class="home-widget bg-secondary text-widget radius-card h-100">
                    <p>{{this.$t("settings.graphPro")}} <b-link @click="passaAPro" >{{this.$t("settings.activePro")}}</b-link></p>
                    <img src="img/donut_obscure_sfocato_little.png" class = "img-fluid">
                </b-card>

            </b-col>
            </b-row>


            <!-- TABELLA REPORT LOGBOOK TEST FUNZIONALE E TEST DI AUTONOMIA-->
            <b-row class="mt-4">

                <b-col cols="12">

                    <b-card class="home-widget text-widget radius-card ml-4 mr-4 mb-4">
                     <template v-slot:header style="background:white">
                        <div>
                            <span class="mr-2">{{$t('report_table.title_logbook')}}<br>
                            <span class="typo-littleblack"><i class="fas fa fa-1x fa-clock-o mr-2"></i>Timezone location: {{$store.state.timezoneLocation}}</span></span>
                            <b-button v-if="tableDataLogbook.length>0 && isPro && !$store.getters.isProExpired" class="noborder-button download" @click="createPDF_List_Logbook">
                                <i class="fas fa fa-1x fa-download mr-2"></i>{{ $t("download") }}
                            </b-button>
                        </div>
                     </template>
                     <v-client-table v-if="tableDataLogbook.length>0" :columns="columnsLogbook" :data="tableDataLogbook" :options="optionsLB" :theme="theme" id="dataTable" ref="table" class="borderless text-primary widget-table">
                <!-- in ogni riga un logbook -->
                        <div slot="logdate" slot-scope="props" id="div_timestamp">
                           <strong>{{ dataRep(props.row.log_timestamp).data}}</strong><br/>
                           {{dataRep(props.row.log_timestamp).ora}}
                        </div>
                        <div slot="logtype" slot-scope="props" id="div_test">
                            {{descClassLogType(props.row.log_type)}}
                        </div>
                        <div slot="logcu" slot-scope="props" id="div_cent">
                            <strong class="font-16m">{{props.row.cu_id}}</strong><br/>
                            {{ $t('central_unit') }} {{props.row.log_system}}
                        </div>

                        <!-- check if functional test PASS but at least one luminaire with autonomy error -->
                        <div slot="logstate" slot-scope="props" id="div_stato"
                            v-if="props.row.log_type=='test_funzionale_automatico'  //if functional test
                            && props.row.log_esito=='pass'        //if functional test PASS && error_batt_test_auto=ON on at least one lamp
                            && props.row.log_lamps.some((el) => el.error_batt_test_auto=='ON')"
                            :content="$t('report_table.error_auto_in_funct')" v-tippy="{ placement: 'top', arrow: true}"
                            >

                                <i :class="['fa fa-circle ' + ((props.row.log_esito == 'pass')?'success':'danger'), 'my-auto']"></i>
                                <i class="fa fa-exclamation pl-1" style="color: red"></i>
                        </div>

                        <div slot="logstate" slot-scope="props" id="div_stato" v-else>
                                <i :class="['fa fa-circle ' + ((props.row.log_esito == 'pass')?'success':'danger'), 'my-auto']"></i>
                        </div>

                        <div slot="logdownload" slot-scope="props" id="div_download">
                            <DownloadPdfSingleReport :report="props.row" :plant="$store.state.currentPlant"></DownloadPdfSingleReport></div>
                        <div slot="child_row" slot-scope="props">
                    <!-- logbook SICURO -->
                            <table v-if="props.row.log_system === 'sicuro'" class="table widget-table borderless">
                                <thead>
                                    <tr class="">
                                        <th id="td_index"></th>
                                        <th id="td_empty"></th>
                                        <th id="td_id"><h5>{{$t('details_lamp.lamp_id')}}</h5></th>
                                        <th id="td_desc"><h5>{{$t('details_lamp.lamp_desc')}}</h5></th>
                                        <th id="td_prod"><h5>{{$t('details_lamp.lamp_prod_desc')}}</h5></th>
                                        <th id="td_stato"><h5>{{$t('details_lamp.lamp_state')}}</h5></th>
                                        <th id="td_err"><h5>{{$t('details_lamp.lamp_error')}}</h5></th>
                                        <th id="td_note"><h5>{{$t('details_lamp.lamp_note')}}</h5></th>
                                    </tr>
                                </thead>
                                <tbody>
                            <!-- CENTRALE -->
                                    <tr v-for="(cent) in props.row.log_cu" :key="'c'+ cent.index"> <!--  -->
                                        <td id="td_index">
                                            <!-- <p>{{index}}</p> -->
                                            -
                                        </td>
                                        <td id="td_empty"> </td>
                                        <td id="td_id">
                                            <strong><h5>{{props.row.cu_id}}</h5></strong>
                                        </td>
                                        <td id="td_desc">
                                            <strong>{{props.row.log_system + '_' + props.row.cu_id}}</strong>
                                        </td>
                                        <td id="td_prod">
                                            <strong>{{$t('report_table.central')}}</strong>
                                        </td>
                                        <td id="td_stato">
                                            <i class="fa fa-1x" :class="[dotClassCentralLog(cent)]" />
                                        </td>
                                        <td id="td_err" >
                                            {{getErroriCentrale(cent).slice(2)}} <br>
                                        </td>
                                        <td id="td_note">
                                            Tinit={{cent.temperature_start}}<br>
                                            Tend={{cent.temperature_end}}
                                        </td>
                                    </tr>
                            <!-- LINEE -->
                                    <tr v-for="(line) in props.row.log_lines" :key="'l' + line.index"> <!-- :key="line.index"> -->
                                        <td id="td_index">
                                            <!-- <p>{{line.index}}</p> -->
                                            -
                                        </td>
                                        <td id="td_empty"> </td>
                                        <td id="td_id">
                                            <strong><h5>AK {{line.ak}} </h5></strong>
                                        </td>
                                        <td id="td_desc">
                                        <strong>LINE {{line.line_num?line.line_num:"0" + line.index}}</strong>
                                        </td>
                                        <td id="td_prod">
                                        </td>
                                        <td id="td_stato">
                                            <i class="fa fa-1x" :class="[dotClassLineLog(line)]" />
                                        </td>
                                        <td id="td_err" >
                                            {{getErroriLines(line).slice(2)}} <br>
                                        </td>
                                        <td id="td_note">
                                        </td>
                                    </tr>
                            <!-- LINEE EXT-->
                                    <tr v-for="(line) in props.row.log_lines_ext" :key="'lext' + line.index"> <!-- :key="line.index"> -->
                                        <td id="td_index">
                                            <!-- <p>{{line.index}}</p> -->
                                            -
                                        </td>
                                        <td id="td_empty"> </td>
                                        <td id="td_id">
                                            <strong><h5>AK_EXT {{line.ak}}</h5></strong>
                                        </td>
                                        <td id="td_desc">
                                        <strong>LINE {{line.line_num?line.line_num:"0" + line.index}}</strong>
                                        </td>
                                        <td id="td_prod">
                                        </td>
                                        <td id="td_stato">
                                            <i class="fa fa-1x" :class="[dotClassLineLog(line)]" />
                                        </td>
                                        <td id="td_err" >
                                            {{getErroriLines(line).slice(2)}} <br>
                                        </td>
                                        <td id="td_note">
                                        </td>
                                    </tr>
                            <!-- LAMPADE SICURO -->
                                    <tr v-for="(lamp) in props.row.log_lamps" :key="'lamp' + lamp.index"> <!-- :key="lamp.index"> -->
                                        <td id="td_index">
                                            <p>{{lamp.index}}</p>
                                        </td>
                                        <td id="td_empty"> </td>
                                        <td id="td_id">
                                            <strong><h5>{{lamp.id}}</h5></strong>
                                        </td>
                                        <td id="td_desc">
                                        <strong>{{lamp.descr}}</strong>
                                        </td>
                                        <td id="td_prod">
                                            <strong v-if="lampSicuroDet(lamp.id).product_desc!=null">{{lampSicuroDet(lamp.id).product_desc.includes('|')?lampSicuroDet(lamp.id).product_desc.split('|')[0]:lampSicuroDet(lamp.id).product_desc}}</strong>
                                            <strong v-else>--</strong><br/>
                                            <p v-if="lampSicuroDet(lamp.id).product_code!=null">cod: {{lampSicuroDet(lamp.id).product_code.includes('|')?lampSicuroDet(lamp.id).product_code.split('|')[0]:lampSicuroDet(lamp.id).product_code}}</p>
                                        </td>
                                        <td id="td_stato">
                                            <i class="fa fa-1x" v-bind:class="[dotClassLog(lamp)]" />
                                        </td>
                                        <td id="td_err" >
                                            {{descClassLog(lamp)}} <br>
                                        </td>
                                        <td id="td_note">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table v-else class="table widget-table borderless">
                                <thead>
                                <tr class="">
                                    <th id="td_index"></th>
                                    <th id="td_empty"></th>
                                    <th id="td_id"><h5>{{$t('details_lamp.lamp_id')}}</h5></th>
                                    <th id="td_desc"><h5>{{$t('details_lamp.lamp_desc')}}</h5></th>
                                    <th id="td_prod"><h5>{{$t('details_lamp.lamp_prod_desc')}}</h5></th>
                                    <th id="td_stato"><h5>{{$t('details_lamp.lamp_state')}}</h5></th>
                                    <th id="td_err"><h5>{{$t('details_lamp.lamp_error')}}</h5></th>
                                    <th id="td_note"><h5>{{$t('details_lamp.lamp_note')}}</h5></th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(lamp, index) in props.row.log_lamps" v-bind:key="lamp.id">
                                        <td id="td_index">
                                            <p>{{lamp.index}}</p>
                                        </td>
                                        <td id="td_empty"> </td>
                                        <td id="td_id">
                                            <strong><h5>{{lamp.id}}</h5></strong>
                                        </td>
                                        <td id="td_desc">
                                        <strong>{{lamp.descr}}</strong>
                                        </td>
                                        <td id="td_prod">
                                            <strong v-if="lampDet(lamp.id).product_desc!=null">{{lampDet(lamp.id).product_desc.includes('|')?lampDet(lamp.id).product_desc.split('|')[0]:lampDet(lamp.id).product_desc}}</strong>
                                            <strong v-else>--</strong><br/>
                                            <p v-if="lampDet(lamp.id).product_code!=null">cod: {{lampDet(lamp.id).product_code.includes('|')?lampDet(lamp.id).product_code.split('|')[0]:lampDet(lamp.id).product_code}}</p>
                                        </td>
                                        <td id="td_stato">
                                            <i class="fa fa-1x" v-bind:class="[dotClassLog(lamp)]" />
                                        </td>
                                        <td id="td_err" >
                                            {{descClassLog(lamp)}} <br>
                                        </td>

                                        <td :id="'td_note_' + props.row.log_timestamp + '_' + props.row.cu_id +'_' + lamp.id">
                                        <tr id="tr_note" :key="index">
                                                <td v-if="!isNoteEditable" cols="9" sm="10" >
                                                    <strong>{{getLogbookNote(lamp.id)}}</strong>
                                                </td>
                                                <td v-if="isNoteEditable" cols="7" sm="8">
                                                    <div role="group">
                                                        <b-form-input id="lampNote" type="text" v-model="selectedLampNote"></b-form-input>
                                                    </div>
                                                </td>
                                                <td v-if="isNoteEditable" cols="5" sm="4">
                                                            <b-button v-if="!updatingLampNote" @click="saveNoteLamp">
                                                                <i class="fa fa-check"></i>
                                                            </b-button>
                                                            <b-button v-if="!updatingLampNote" @click="abortNoteLamp" >
                                                                <i class="fa fa-close"></i>
                                                            </b-button>
                                                            <span v-if="updatingLampNote">
                                                                <i class="fa fa-spinner fa-spin"></i>
                                                            </span>
                                                </td>
                                            </tr>
                                            <div style="display:flex; flex-wrap: nowrap; align-items: flex-start">
                                                <span v-if="editingNoteId != (props.row.log_timestamp + '_' + props.row.cu_id +'_' + lamp.id)" style="flex-grow: 1; align-self: center; text-align: center; font-weight: bold; min-width: 240px">{{lamp.note}}</span>
                                                <b-form-textarea v-if="editingNoteId == (props.row.log_timestamp + '_' + props.row.cu_id +'_' + lamp.id)"

                                                    v-model="editingLampNote"
                                                    placeholder="Inserisci le note..."
                                                    rows="3"
                                                    max-rows="10"
                                                    style="flex-grow: 1;"
                                                    >
                                                </b-form-textarea>
                                                <span v-if="editingNoteId == (props.row.log_timestamp + '_' + props.row.cu_id +'_' + lamp.id)">
                                                    <b-button @click="saveNoteLamp(props.row.log_timestamp,props.row.cu_id, lamp)">
                                                        <i class="fa fa-check"></i>
                                                    </b-button>
                                                    <b-button @click="abortNoteLamp()" >
                                                        <i class="fa fa-close"></i>
                                                    </b-button>
                                                </span>
                                                <b-button v-if="editingNoteId == ''" @click="editNote(props.row.log_timestamp, props.row.cu_id, lamp)">
                                                        <i class="fa fa-edit"></i>
                                                </b-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-client-table>
                        <div v-else>
                            <label style="color:#008BC7">{{$t('report_table.no_report')}}</label>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>

import Vue from 'vue';
import NavBarMain from '@/components/NavBarMain';
import NavBarReport from '@/components/NavBarReport';
import BannerPro from '@/components/BannerPro';
import BannerProExpired from '@/components/BannerProExpired';
import GraficoDonutReport from '@/components/GraficoDonutReport'
import GraficoDonutReportError from '@/components/GraficoDonutReportError'
import DownloadPdfSingleReport from "./DownloadPdfSingleReport.vue";
import {ClientTable, Event} from 'vue-tables-2';
Vue.use(ClientTable);

//import for pdf conversion
import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable' ;
import { mapState } from 'vuex';
import ErrorBanner from '@/components/ErrorBanner';
import { showAt, hideAt } from 'vue-breakpoints'


export default {
    name: 'ReportImpianto',
    components: {
        NavBarMain,
        NavBarReport,
        BannerPro,
        BannerProExpired,
        GraficoDonutReport,
        GraficoDonutReportError,
        ClientTable,
        Event,
        jsPDF,
        JsPDFAutotable,
        DownloadPdfSingleReport,
        ErrorBanner,
        showAt,
        hideAt
    },
    props: ['plantId', 'devicesType'],
    data() {
        return {
            repPres: {
                perPage: 10,
                currentPage: 0
            },
            globalReports: null,
            currentCent: null,
            currentLamp: null,
            selected_num_lamp: null,
            selected_ore_autonomia: null,
            currentLampImage: "",
            righeSel: [],
            columnsGlobalReport: ['reportId','logdownload'],
            columnsLogbook: ['logdate','logcu','logtype','logstate','logdownload'],
            columnsMains: ['logdate','logcu','logtype','logstate'],

            reportPresenzaFields: [
                {key: 'log_timestamp', label:'Data Evento'},
                {key: 'cu_id', label:'Centrale / Tipologia'},
                {key:'log_type', label:'Tipologia Log', tdClass: 'align-middle'},
                {key: 'esito', label:'Esito', tdClass: 'text-center align-middle', thClass: 'text-center'}

            ],

            optionsLB: {
                //uniqueKey: 'log_timestamp' + 'cu_id',
                uniqueKey: 'stable_key',
                headings: {
                    logdate: this.$t("report_table.date"),
                    logtype: this.$t("report_table.log_type"),
                    logcu: this.$t("report_table.central"),
                    logstate: this.$t("report_table.state"),
                    logdownload:''
                },
                perPage: 10,
                perPageValues: [10,20,50],
                texts:{
                    limit: this.$t("report_table.record_per_page"),
                    count:'{count} report'
                },
                pagination: { dropdown:false, chunk:5 },
                filterByColumn: true,
                filterable: ['logdate','logtype','logcu','logstate'],
                listColumns: {
                    logstate: [
                        {id: 'pass', text: 'OK'},
                        {id: 'fail', text: 'ERR'}
                    ],
                    logtype: [
                        {id: 'test_autonomia', text: 'Test Autonomia'},
                        {id: 'test_autonomia_automatico', text: 'Test Autonomia Automatico'},
                        {id: 'test_autonomia_manuale', text: 'Test Autonomia Manuale'},
                        {id: 'test_funzionale', text: 'Test Funzionale'},
                        {id: 'test_funzionale_automatico', text: 'Test Funzionale Automatico'},
                        {id: 'test_funzionale_manuale', text: 'Test Funzionale Manuale'},
                    ]
                },
                filterAlgorithm: {
                    logstate(row,query) {
                        //console.log("filtro logstate " + query, row);
                        return row.log_esito == query;
                    },
                    logtype(row,query) {
                        //console.log("filtro logtype " + query, row);
                        return row.log_type.indexOf(query) >= 0;
                    },
                    logcu(row,query) {
                        return row.cu_id.toLowerCase().indexOf(query.toLowerCase()) >= 0;
                    },
                    logdate(row,query) {
                        var fromDate = null;
                        var toDate = null;
                        if (query.indexOf(',') >= 0) {
                            var darr = query.split(',', -1);
                            fromDate = Vue.prototype.moment(darr[0].trim(), ['DD MM YYYY']).startOf('day'); //ensure start of the day
                            toDate = Vue.prototype.moment(darr[1].trim(), ['DD MM YYYY']).endOf('day'); //set to very end of the day
                        } else {
                            fromDate = Vue.prototype.moment(query.trim(), ['DD MM YYYY']);
                            toDate = Vue.prototype.moment();
                        }
                        //console.log("filtro data (" + query + ")", fromDate.format(), toDate.format());
                        //console.log("row:",row);
                        if (!fromDate.isValid() || !toDate.isValid()) return false;
                        var fromTS = fromDate.unix();
                        var toTS = toDate.unix();
                        if (toTS < fromTS) return false;
                        var logDate = parseInt(row.log_timestamp);
                        //console.log("logDate:" + row.log_date+", " + logDate+", from: "+fromTS+" - " + fromDate.format()+", to: " + toTS);
                        if (fromTS > logDate || toTS < logDate) return false;
                        return true;
                    }

                }

            },
            optionsMains: {
                uniqueKey: 'log_timestamp',
                headings: {
                    logdate: this.$t("report_table.date"),
                    logtype: 'Tipo Evento',
                    logcu: this.$t("report_table.central"),
                    logstate: '',

                },
                perPage: 10,
                perPageValues: [10,20,50],
                texts:{
                    limit: this.$t("report_table.record_per_page"),
                    count:'{count} report'
                },
                pagination: { dropdown:false, chunk:5 },
                filterByColumn: true,
                filterable: ['logdate','logtype','logcu'],
                listColumns: {
                    logtype: [
                        {id: 'assenza_rete', text: 'Assenza Rete'},
                        {id: 'rientro_rete', text: 'Rientro Rete'},

                    ]
                },
                filterAlgorithm: {

                    logtype(row,query) {
                        //console.log("filtro logtype " + query, row);
                        return row.log_type.indexOf(query) >= 0;
                    },
                    logcu(row,query) {
                        return row.cu_id.toLowerCase().indexOf(query.toLowerCase()) >= 0;
                    },
                    logdate(row,query) {
                        var fromDate = null;
                        var toDate = null;
                        if (query.indexOf(',') >= 0) {
                            var darr = query.split(',', -1);
                            fromDate = Vue.prototype.moment(darr[0].trim(),['DD MM YYYY']);
                            toDate = Vue.prototype.moment(darr[1].trim(), ['DD MM YYYY']);
                        } else {
                            fromDate = Vue.prototype.moment(query.trim(), ['DD MM YYYY']);
                            toDate = Vue.prototype.moment();
                        }
                        //console.log("filtro data (" + query + ")", fromDate.format(), toDate.format());
                        //console.log("row:",row);
                        if (!fromDate.isValid() || !toDate.isValid()) return false;
                        var fromTS = fromDate.unix();
                        var toTS = toDate.unix();
                        if (toTS < fromTS) return false;
                        var logDate = parseInt(row.log_timestamp);
                        //console.log("logDate:" + row.log_date+", " + logDate+", from: "+fromTS+" - " + fromDate.format()+", to: " + toTS);
                        if (fromTS > logDate || toTS < logDate) return false;
                        return true;
                    }

                }


            },
            optionsGlobalReport: {
                uniqueKey: 'reportId',
                headings: {
                    reportId: this.$t("report_table.date"),
                    logdownload:''
                },
                perPage: 10,
                perPageValues: [10,20,50],
                texts:{
                    limit: this.$t("report_table.record_per_page"),
                    count:'{count} report'
                },
                pagination: { dropdown:false, chunk:5 },
                filterByColumn: false,
                filterable: [],
            },
            theme: 'bootstrap4',
            template: 'default',

            options_lamp: [
                    { value: 1, text: '1' },
                    { value: 2, text: '2' },
                    { value: 3, text: '3' },
                    { value: 4, text: '4' },
                    { value: 5, text: '5' },
                    { value: 6, text: '6' },
                    { value: 7, text: '7' },
                    { value: 8, text: '8' },
                    { value: 9, text: '9' },
                    { value: 10, text: '10' },
                    { value: 11, text: '11' },
                    { value: 12, text: '12' },
                    { value: 13, text: '13' },
                    { value: 14, text: '14' },
                    { value: 15, text: '15' },
                    { value: 16, text: '16' },
                    { value: 17, text: '17' },
                    { value: 18, text: '18' },
                    { value: 19, text: '19' },
                    { value: 20, text: '20' },
                    { value: 21, text: '21' },
                    { value: 22, text: '22' },
                    { value: 23, text: '23' },
                    { value: 24, text: '24' },
                    { value: 25, text: '25' },
                    { value: 26, text: '26' },
                    { value: 27, text: '27' },
                    { value: 28, text: '28' },
                    { value: 29, text: '29' },
                    { value: 30, text: '30' },
                    { value: 31, text: '31' },
                    { value: 32, text: '32' }
                    ],
            //selectedLampNote: "",
            isNoteEditable: false,
            //updatingLampNote: false,
            editingNoteId: "",
            editingLampNote: "",

            options_ore_autonomia: [
                    { value: "1H", text: '1H' },
                    { value: "1H5", text: '1H5'},
                    { value: "2H", text: '2H' },
                    { value: "3H", text: '3H' },
                    { value: "8H", text: '8H' }
                    ],

            funct_graph_time: 7300,
            auto_graph_time: 7300,
            graphKeyFunct:0,
            graphKeyLampFunct:0,
            graphKeyAuto:0,
            graphKeyLampAuto:0,
            graphKeyError:0,
            options_funct: [
                    { value: 7300, text: this.$t("report_table.plant_life") },
                    { value: 90, text: this.$t("report_table.last_3month") },
                    { value: 365, text: this.$t("report_table.last_year") },
                    ],
            options_autonomy: [
                    { value: 7300, text: this.$t("report_table.plant_life") },
                    { value: 730, text: this.$t("report_table.last_2year") },
                    { value: 365, text: this.$t("report_table.last_year") },
                    ],

            //Set heading for lamps with errors pdf table
            lamps_columns : [
            {title: "", dataKey: "index"},
            {title: this.$t('report_pdf.title_id_lamp'), dataKey: "id"},
            {title: this.$t('report_pdf.title_desc_lamp'), dataKey: "desc"},
            {title: this.$t('report_pdf.title_code_lamp'), dataKey: "code"},
            {title: this.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"},
            {title: this.$t('central_unit'), dataKey: "cuName"},
            {title: this.$t('report_pdf.title_error_lamp'), dataKey: "errori"}],
            lamps_rows : [],

            //Set heading for lmaps with errors pdf table
            error_solution_columns : [
            {title: this.$t('report_pdf.title_id_lamp'), dataKey: "id"},
            {title: this.$t('report_pdf.title_error_lamp'), dataKey: "lamp_error"},
            {title: this.$t('report_pdf.title_error_solution'), dataKey: "error_solution"},
            {title: this.$t('details_lamp.spare_parts_code'), dataKey: "spare_parts_code"},
            {title: this.$t('details_lamp.spare_parts_desc'), dataKey: "spare_parts_desc"}],
            error_solution_rows : [],

            //Set heading for spare parts_bom pdf table
            spare_parts_bom_columns : [
            {title: this.$t('report_pdf.quantity'), dataKey: "bom_quantity"},
            {title: this.$t('details_lamp.spare_parts_code'), dataKey: "bom_code"},
            {title: this.$t('details_lamp.spare_parts_desc'), dataKey: "bom_desc"}],
            spare_parts_bom_rows : [],

            indexSicuro: 0,
            tipoDispositivo: this.devicesType,
            // Data properties to hold the loaded font strings
            robotoRegular: null,
            robotoBold: null,
            graphKeyLamp: 0,
            isBothType: false,
            imgData : 'data:image/jpeg;base64,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'
        }

    },

    filters: {
        tipoCentrale: function(value) {
            if (value == 'cablecom') return "Centrale CableCom"
            return "Centrale " + value
        },

        descrStato: function(value) {
            var stato = (value.cu_connected) ? "Connessa" : "Disconnessa"
            if (value.num_lamp_found==0) {
                stato = "Non configurata"
            }
            if (value.num_lamp_error > 0) {
                stato = "Errore"
            } else  {
                var err = value.cu_error;
                if (
                    err.error_batt_low_voltage == 'ON' ||
                    err.error_batt_not_connected == 'ON' ||
                    err.error_duplicated_id_lamp == 'ON' ||
                    err.error_lg == 'ON' ||
                    err.error_wiring == 'ON' ||
                    err.error_too_much_lamp_in_config == 'ON' ||
                    err.error_overload == 'ON' ||
                    err.error_missing_lamp_in_config == 'ON' ||
                    err.error_more_32_lamp_in_config == 'ON'
                ) stato = "Errore"
            }
            return stato
        }
    },
    computed: {
        ...mapState(['loading','error']),

        isPro() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return false;
            return (plant.plant_type == 'pro' || plant.plant_type == 'premium');
        },

        logbooksFromStore() {
          return this.$store.state.currentLogbooks;
        },
        commandResponseReceived() {
            //console.log("response received: ", this.$store.state.commandResponse)
            //return this.$store.state.commandResponse
            return this.$store.state.sticazzi;
        },
        logbookDetails() {
            const logbook = this.$store.state.currentLogbooks;
            console.log("logbook trovata",logbook);
            //if (plant == null) return null;
            //if (plant.id != this.plantId) return null;
            return logbook;
        },
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null) return null;
            if (plant.id != this.plantId) return null;
            return plant;
        },
        Details() {
            return this.$store.state.plantUnits;
        },
        tableDataGlobalReport() {
            if (this.globalReports != null) return this.globalReports;
            return [];
        },
        tableDataLogbook() {
            let self=this;
            var currLogbook=this.$store.state.currentLogbooks.filter(function(item)
            {
                if(self.tipoDispositivo==null)
                    return (item.log_type=="report_illuminazione")
                else
                {
                  if (self.tipoDispositivo=="emergenza")
                    return (item.log_type!="assenza_rete" && item.log_type!="rientro_rete" && item.log_type!="vuoto" && item.log_type!="report_illuminazione")
                  else
                    return (item.log_type=="report_illuminazione")
                }
            });
            //sort for date
            currLogbook.sort(function(a, b) {
                return b.log_timestamp - a.log_timestamp;
            });

            // Use the index to combine it with existing fields for uniqueness
            currLogbook = currLogbook.map((row, index) => ({ ...row, stable_key: row.log_timestamp + '-' + index}));

            if(!self.isPro || (self.isPro && self.$store.getters.isProExpired))
            {
              // 1. Otteniamo il timestamp attuale in secondi (10 cifre)
              const oraInSecondi = Math.floor(Date.now() / 1000);

              // 2. Calcoliamo i secondi in un anno (365 giorni)
              const secondiInUnAnno = 365 * 24 * 60 * 60;

              // 3. Calcoliamo il cutoff a 10 cifre
              const cutOff = oraInSecondi - secondiInUnAnno;

              console.log(cutOff); // Esempio: 1745932653
              console.log("cutoff 1 year",cutOff, currLogbook);

              // 2. Filtriamo l'array
              const logUltimoAnno = currLogbook.filter(log => log.log_timestamp >= cutOff);
              console.log("cutoff 1 year logbooks",logUltimoAnno);
              return logUltimoAnno;
            }

            console.log ("currLogbook: " ,currLogbook);
            return currLogbook;
        },
        tableDataMains() {
            //select mains
            var currentMains=this.$store.state.currentLogbooks.filter(function(item)
            {
                return (item.log_type=="assenza_rete" || item.log_type=="rientro_rete")
            });

            //sort for date
            currentMains.sort(function(a, b) {
                return b.log_timestamp - a.log_timestamp;
            });
            console.log ("currentMains: " ,currentMains);
            return currentMains;
        },
        numUnits() {
            if (this.unitsDetails==null) return 0;
            return this.unitsDetails.length;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        // Restituisce il numero totale di lampade dell'impianto
        // aggiornata Sicuro
        totalLamps() {
          if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;

          const isEmergenza = this.tipoDispositivo === "emergenza";
          return this.unitsDetails.reduce((total, u) => {
              if((u.cu_type=="cablecom" || u.cu_type ==="sicuro") && isEmergenza)
                  return total + (u.num_lamp_found | 0);
              else
              {
                  if (isEmergenza)
                    return total + (u.lamps.length | 0);
                  else
                    return total + (u.lamps_illum.length | 0);
              }
          }, 0);
        },
        //fornisce la lista degli id di tutte le lampade presenti nell'impianto
        //(viene eseguita una volta e poi si usa il valore in cache fino a quando non cambia unitsDetails)
        lampsList() {

          if (!this.unitsDetails || this.unitsDetails.length === 0) return [];

          const isEmergenza = this.tipoDispositivo === "emergenza";
          const propertyToExtract = isEmergenza ? "lamps_id" : "lamps_illum_id";

          // .flatMap() prende gli array da ciascuna centrale e li mette dentro un nuova singola lista
          // carico gli id di LogicaFM e SICURO
          let list = this.unitsDetails.flatMap(u => u[propertyToExtract] || []);
          this.unitsDetails.forEach((u) => {
            if (u.cu_type === 'logica' || u.cu_type === 'blegateway') {
              list.push(...(u.device_0_31 || []));
              list.push(...(u.device_32_63 || []));
              if (u.cu_type === 'logica') {
                list.push(...(u.device_64_95 || []));
                list.push(...(u.device_96_127 || []));
              }
            }
          })
          //per sicurezza restituiamo un Set che elimina eventuali id duplicati
          return [...new Set(list)];
        },

        graphLampLogbook() {
            if (this.$store.state.plantUnits == null || this.unitsDetails == null || this.$store.state.currentLogbooks==null) return null;
            //this.graphKeyLamp++;
            return ["lamp",this.totalLamps,this.numLampReportPass,this.numLampReportFail,this.numLampReportNotExecuted,this.numLampReportOrphan];
        },
        //resituisce i dati per la tabella che contiene le lampade con errore (sotto al donut di dx, errori dai test automatici)
        tableLampsWithErrors(){

            if (this.$store.state.plantUnits == null || this.unitsDetails == null) return null;

            const self = this;

            //Fill row with data from snapshot
            var logbook_snapshot= this.reportCentData;

            //get list of last logbooks for pdf print
            var rows=[];
            rows=this.getLastLogbook(self,logbook_snapshot);

            //get list of lamps with errors for donut error lamps type and download print
            var lamps_rows=[];
            lamps_rows=this.getLampsWithErrorInLogbook(self,rows);

            return lamps_rows;
        },

        //fornisce i dati degli errori per la visualizzazione per GraficoDonutReportError.vue
        graphLampsErrorType(){

            if (this.$store.state.plantUnits == null || this.unitsDetails == null) return null;
            //this.graphKeyError++;

            const self = this;

            //Fill row with data from snapshot
            var logbook_snapshot = this.reportCentData;
            console.log("graphLampsErrorType: SNAPSHOT LAST LOGBOOK", logbook_snapshot);

            //get list of last logbooks for pdf print
            var rows=[];
            rows=this.getLastLogbook(self,logbook_snapshot);
            console.log("graphLampsErrorType: FUNCTION ROWS FROM GET LAST LOGBOOK", rows);

            //get list of lamps with errors for donut error lamps type and download print
            var lamps_rows=[];
            lamps_rows=this.getLampsWithErrorInLogbook(self,rows);
            console.log("FUNCTION LAMPS ROWS FROM GET LAMPS WITH ERRORS",lamps_rows);

            var numBattShort=0;
            var numBattFunctError=0;
            var numBattAutoError=0;
            var numComError=0;
            var numLedError=0;
            var numHwError=0;
            var numUvoxyError=0;
            var numLineFuseError=0;

            var numOrphan=0;
            var numCommRadioLampError=0;
            var numOverpowerError=0;
            var numOvervoltageError=0;
            var numUnderpowerError=0;
            var numUndervoltageError=0;

            //SICURO
            var numDaliError = 0;
            var numUnderThresholdError = 0;
            var numProgError = 0;
            var numBusVoltError = 0;
            var numDuplicateError = 0;

            lamps_rows.forEach(function(lamp) {
                //console.log("Lamp: ", lamp);
                const raw = lamp.lamp_raw;
                //logica, logicaFM, cablecom
                if( raw.error_batt_short =="ON" &&
                    raw.error_batt_test == "ON" &&
                    raw.error_batt_test_auto == "ON" &&
                    raw.error_batt_test_funz == "ON" &&
                    raw.error_com == "ON" &&
                    raw.error_hardware == "ON" &&
                    raw.error_led =="ON" &&
                    raw.error_ricarica_incompleta == "ON")  numOrphan++;
                else if (raw.error_comm_radio_lamp=="ON" || (raw.error_hardware == 'ON' && raw.error_com == 'ON')) numCommRadioLampError++;
                else if (raw.error_hardware == 'ON' && raw.error_com == 'OFF') numHwError++;
                else if (raw.error_com=="ON") numComError++;
                else if (raw.error_led == 'ON') numLedError++;
                else if (raw.error_batt_short == 'ON') numBattShort++;
                else if (raw.error_batt_test=="ON" || raw.error_batt_test_funz=="ON") numBattFunctError++;
                else if (raw.error_batt_test_auto=="ON") numBattAutoError++;
                else if (raw.error_tubo_UV=="ON") numUvoxyError++;
                else if (raw.error_underpower=="ON") numUnderpowerError++;
                else if (raw.error_undervoltage=="ON") numUndervoltageError++;
                else if (raw.error_overpower=="ON") numOverpowerError++;
                else if (raw.error_overvoltage=="ON") numOvervoltageError++;

                if (lamp.cuName.split('-')[0].toLowerCase() === 'sicuro') {
                    //Sicuro
                    if (raw.error_com_ak_lamp === 'ON') numComError++;
                    else if (raw.error_line_fuse === 'ON') numLineFuseError++;
                    else if (raw.error_led_open === 'ON' || raw.error_led_full_short === 'ON' || raw.error_led_partial_short === 'ON') numLedError++;
                    else if (raw.error_dali_com === 'ON' || raw.error_dali_hardware === 'ON' || raw.error_dali_lamp === 'ON') numDaliError++;
                    else if (raw.error_low_voltage === 'ON' || raw.error_polarity_reverse === 'ON') numBusVoltError++;
                    else if (raw.error_under_threshold === 'ON') numUnderThresholdError++;
                    else if (raw.error_lamp_programming === 'ON') numProgError++;
                    else if (raw.error_id_duplicate === 'ON') numDuplicateError++;
                }
            } );

            console.log("LAMP ERRORS: ", [this.numLampReportFail, numHwError,numLedError,numBattShort,numBattFunctError,numBattAutoError,numComError, numUvoxyError, numUnderpowerError, numUndervoltageError , numOverpowerError, numOvervoltageError, numCommRadioLampError, numOrphan, numDaliError, numUnderThresholdError, numProgError, numBusVoltError, numDuplicateError,numLineFuseError]);
            return [this.numLampReportFail, numHwError,numLedError,numBattShort,numBattFunctError,numBattAutoError,numComError, numUvoxyError, numUnderpowerError, numUndervoltageError , numOverpowerError, numOvervoltageError, numCommRadioLampError, numOrphan, numDaliError, numUnderThresholdError, numProgError, numBusVoltError, numDuplicateError, numLineFuseError];

        },
        lastLogbook(){
            var report=[];
            if(this.unitsDetails!=null)
            {
                for(var i=0;i<this.unitsDetails.length;i++)
                {
                    var temp_report=this.logbookUnits(this.unitsDetails[i].cu_id);
                    if(temp_report!=null)
                        report.push(temp_report[0]);
                }
            }
            return report;
        },
        reportCentData() {
            var centData = [];
            var ll = this.lastLogbook;
            if (ll != null && this.unitsDetails != null) {
                console.log("reportCentData: lastLogbook:", ll);
                console.log("unitsDet", this.unitsDetails)

                for (var i=0; i< this.unitsDetails.length; i++) {
                    let cent = this.unitsDetails[i];
                    let lbCent = this.lastLogbook.find(function(l) {
                        if (l == null || l == undefined) return false;
                        return l.cu_id == cent.cu_id;
                    });
                    if (lbCent == null) {
                        centData.push({cu_id: cent.cu_id , cu_desc: cent.cu_type+"-"+cent.cu_id, status: 0, log_system: cent.cu_type})
                    } else {
                        if (lbCent.log_system === "sicuro")
                        {
                            centData.push({ cu_id: cent.cu_id, cu_desc: cent.cu_type + "-" + cent.cu_id, status: (lbCent.log_esito == 'pass') ? 1 : -1, log_system: cent.cu_type, report_date: lbCent.log_timestamp, report_type: lbCent.log_type, log_cu: lbCent.log_cu, log_lines: lbCent.log_lines, log_lines_ext: lbCent.log_lines_ext, log_lamps: lbCent.log_lamps, report_result: lbCent.log_esito })
                        } else {
                            centData.push({ cu_id: cent.cu_id, cu_desc: cent.cu_type + "-" + cent.cu_id, status: (lbCent.log_esito == 'pass') ? 1 : -1, log_system: cent.cu_type, report_date: lbCent.log_timestamp, report_type: lbCent.log_type, log_lamps: lbCent.log_lamps, report_result: lbCent.log_esito })
                        }
                    }
                }
            }

            if (this.tipoDispositivo != "emergenza")
            {
                return centData.filter(function(item)
                {
                    return (item?item.report_type=="report_illuminazione":null)
                });
            }
            else
            {
                console.log("reportCentData: ", centData);
                return centData;
            }
        },
        lastFunctPass()
        {
            var functLogbookPass=this.lastLogbook.filter(function(item)
            {
                return (item?item.log_esito=="pass":null)
            });
             return functLogbookPass;

        },
        //fornisce il numero complessivo di lampade senza errore presenti nell'impianto (controllando ogni singola cu)
        //aggiornato Sicuro
        numLampReportPass()
        {
            console.log("numLampReportPass: lastLogbook:",this.lastLogbook)
            var numLampFunctPass=0;

            console.log("numLampReportPass: lampsList:", this.lampsList);
            console.log("numLampReportFail: lastLogbook:", this.lastLogbook);
            console.log("numLampReportFail: tipoDispositivo: ", this.tipoDispositivo);
            //seleziono l'ultimo logbook di ogni CentralUnit
            for (var i=0; i< this.lastLogbook.length; i++) {
                let lb = this.lastLogbook[i];
                if (lb == null) continue;
                    //seleziono ciascuna lampada presente nel logbook e verifico se è presente o meno un errore
                    for (var l=0;l<lb.log_lamps.length;l++) {
                      let lmp = lb.log_lamps[l];
                      if (!this.lampsList.includes(lmp.id)) continue; // Considero solo le lampade che sono effettivamente presenti nell'impianto

                      if ((this.tipoDispositivo === "emergenza") && (this.calcolaNumErrori(lmp) === 0))
                      {
                          numLampFunctPass += 1;
                      }
                      else if ((this.tipoDispositivo === "illuminazione") && (this.calcolaNumErrori(lmp) === 0) && (lmp.nodo_orfano === false))
                      {
                          numLampFunctPass += 1;
                      }
                    }
            }
            console.log("numLampReportPass: ", numLampFunctPass);
            return numLampFunctPass;
        },
        lastFunctFail()
        {
            var functLogbookFail=this.lastLogbook.filter(function(item)
            {
               return (item?item.log_esito!="pass":null)
            });
            return functLogbookFail;
        },
        //fornisce il numero complessivo di lampade con errore presenti nell'impianto (controllando ogni singola cu)
        //aggiornato Sicuro
        numLampReportFail()
        {
            var numLampFunctFail=0;

            for (var i=0; i< this.lastLogbook.length; i++) {
                let lb = this.lastLogbook[i];
                if (lb == null) continue;

                for (var l=0;l<lb.log_lamps.length;l++) {
                    let lmp = lb.log_lamps[l];
                    if (!this.lampsList.includes(lmp.id)) continue;

                    if ( // Condizione nodo orfano nei report
                        lmp.error_batt_short =="ON" &&
                        lmp.error_batt_test == "ON" &&
                        lmp.error_batt_test_auto == "ON" &&
                        lmp.error_batt_test_funz == "ON" &&
                        lmp.error_com == "ON" &&
                        lmp.error_hardware == "ON" &&
                        lmp.error_led =="ON" &&
                        lmp.error_ricarica_incompleta == "ON")
                    {
                        // Se sono presenti tutti gli errori il nodo è orfano e deve essere conteggiato a parte, quindi non aggiungo nulla
                        numLampFunctFail = numLampFunctFail + 0;
                    }
                    else if ((this.tipoDispositivo === "emergenza") && (this.calcolaNumErrori(lmp) > 0))
                    {
                        //console.log("lamp: ", lmp.id ? lmp.id : lmp.lamp_id, "error: ", this.calcolaNumErrori(lmp));
                        numLampFunctFail += 1;
                    }
                    else if ((this.tipoDispositivo === "illuminazione") && ((this.calcolaNumErrori(lmp) > 0)))
                    {
                        //console.log("lamp: ", lmp.id ? lmp.id : lmp.lamp_id, "error: ", this.calcolaNumErrori(lmp));
                        numLampFunctFail += 1;
                    }
                }
            }
            return numLampFunctFail;
        },

        numLampReportOrphan()
        {
            var numLampOrphan=0;

            for (var i=0; i< this.lastLogbook.length; i++) {
                let lb = this.lastLogbook[i];
                if (lb == null) continue;

                for (var l=0;l<lb.log_lamps.length;l++) {
                    let lmp = lb.log_lamps[l];
                    if (!this.lampsList.includes(lmp.id)) continue;
                    if  (lmp.error_batt_short =="ON" &&
                         lmp.error_batt_test == "ON" &&
                         lmp.error_batt_test_auto == "ON" &&
                         lmp.error_batt_test_funz == "ON" &&
                         lmp.error_com == "ON" &&
                         lmp.error_hardware == "ON" &&
                         lmp.error_led =="ON" &&
                         lmp.error_ricarica_incompleta == "ON")
                    {
                        numLampOrphan += 1;
                    }
                }
            }
            return numLampOrphan;
        },

        // numLampReportFailUvoxy()
        // {
        //     var numLampUvoxyFail=0;

        //     for (var i=0; i< this.lastLogbook.length; i++) {
        //         let lb = this.lastLogbook[i];
        //             if (lb == null) continue;

        //             for (var l=0;l<lb.log_lamps.length;l++) {
        //                 let lmp = lb.log_lamps[l];
        //                 if (!this.lampsList.includes(lmp.id)) continue;
        //                 if (lmp.error_tubo_UV == "ON") {
        //                     if (lmp.error_com == 'ON' && lmp.error_hardware == 'ON' && lmp.error_batt_short == 'ON' && lmp.error_led == 'ON')
        //                         console.log("nodo orfano, nessun errore uvoxy")
        //                     else
        //                     {
        //                         console.log("lampada in errore uvoxy cent: " + lb.cu_id+" ->" + lmp.id);
        //                         numLampUvoxyFail += 1;
        //                     }
        //                 }
        //             }

        //     }

        //     return numLampUvoxyFail;
        // },
        numLastFunctNotExecuted()
        {
            var numNotExecuted;
            if (this.unitsDetails!=null)
                numNotExecuted=this.unitsDetails.length - this.lastFunctPass.length - this.lastFunctFail.length;
            return numNotExecuted;
        },
        numLampReportNotExecuted()
        {
            var numNotExecuted;
            if (this.unitsDetails!=null)
              //numNotExecuted=this.totalLamps - this.numLampReportPass - this.numLampReportFail - this.numLampReportFailUvoxy - this.numLampReportOrphan;
            numNotExecuted=this.totalLamps - this.numLampReportPass - this.numLampReportFail - this.numLampReportOrphan;
            console.log("numLampReportNotExecuted: tot_lamps=" + this.totalLamps + ", pass=" + this.numLampReportPass + ", fail=" + this.numLampReportFail + ", orphan=" + this.numLampReportOrphan);
            return numNotExecuted;
        }
    },
    async mounted() {
        console.log("Logbook page mounted, idImpianto=" + this.plantId + ", logbookDetails:" + ((this.logbookDetails == null) ? "null" : "Object[" + this.logbookDetails.length + "]") )
        if (this.$store.state.user != null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            this.$store.dispatch('loadLogbookDetails', this.plantId);
            if (this.globalReports == null) this.loadGlobalReports();
        }

        // Call the method to load fonts when the component is mounted
        await this.loadFonts();
    },
    updated() {
        console.log("Logbook page updated, idImpianto=" + this.plantId+", logbookDetails=", ((this.logbookDetails == null) ? "null" : "Object[" + this.logbookDetails.length +"]") + ", error:" + this.error)
        if (this.logbookDetails == null && this.error == null && this.$store.state.user != null) {
             this.$store.dispatch('loadLogbookDetails', this.plantId)

        }
        if (this.globalReports == null && this.error == null && this.$store.state.user != null) {
             this.loadGlobalReports();

        }
    },
    watch:
    {
        '$route'() {
            // TODO: react to navigation event.
            // params cotains the current route parameters
            console.log("route changed!",this.$route.params, this.devicesType);
            this.tipoDispositivo = this.devicesType;
        },

        loading(val,oldval) {
            console.log("loading changed:" + val+", error=" + this.error + ", unit details=", this.unitsDetails)
            if (val == false && this.plantDetails == null && this.error == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.unitsDetails == null && this.error == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            }
            else
            {
                this.graphKeyLamp++;
            }
        },

        graphLampLogbook(newval,oldval)
        {
            console.log("graphLampLogbook changed:", newval, oldval);
            if (newval!=oldval)
                this.graphKeyLamp++;
        },

        //serve per definire il devicesType quando sono stati caricati i logbooks da remoto
        logbooksFromStore: {
           handler(newVal) {
            console.log("currentLogbook nuovo, ", newVal);
            if (newVal && newVal.length > 0) {
              this.checkDeviceTypes();
            }
           },
           immediate: true //run immediatly
        }
    },
    methods: {

      passaAPro() {
             this.$router.push({
                name: "GeneraliImpianto",
                params: { plantId: this.$store.state.currentPlant.id }
            });
        },

        //Loads all required fonts and stores them in component data.
        async loadFonts() {
            try {
                // Assumes fonts are in your 'public' folder
                this.robotoRegular = await this.loadFontAsBase64('/fonts/Roboto-Regular.ttf');
                this.robotoBold = await this.loadFontAsBase64('/fonts/Roboto-Bold.ttf');
                //console.log('Fonts loaded successfully.');
            } catch (error) {
                console.error('Failed to load fonts:', error);
            }
        },
        // Helper function to load a font from a URL and convert it to Base64
        async loadFontAsBase64(url) {
            const response = await fetch(url);
            // console.log("fetch font: ", response);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Get the Base64 string, but strip the "data:..." prefix
                    const base64data = reader.result.split(',')[1];
                    resolve(base64data);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },

        checkDeviceTypes() {
            const list = this.$store.state.currentLogbooks;
            if (!list || list.length === 0) return; //si aspetta finchè non viene caricato

            //check for emergency logbook
            let emergency = list.some(item =>
              item && !["assenza_rete", "rientro_rete", "vuoto", "report_illuminazione"].includes(item.log_type)
            );
            //check for lighting logbook
            let lighting = list.some(item =>
              item && item.log_type === 'report_illuminazione' && item.log_lamps.length > 0
            );
            console.log("checkDeviceTypes, emergency: ", emergency, " lighting: ", lighting);
            if (emergency && lighting) {
              this.isBothType = true; // Both
              if (this.tipoDispositivo == null || this.tipoDispositivo === '') {
                this.tipoDispositivo = "illuminazione";
              }
            } else if (emergency) {
              this.isBothType = false; // Emergency
              this.tipoDispositivo = "emergenza";
            } else if (lighting) {
              this.isBothType = false; // Lighting
              this.tipoDispositivo = "illuminazione";
            }
        },


        // BothType()
        // {
            // var emergency_type=false;
            // var lighting_type=false;
            // if (this.$store.state.currentLogbooks!=null)
            // {
            //     this.$store.state.currentLogbooks.forEach((item) => {
            //     if (item!=null && item.log_type!="assenza_rete" && item.log_type!="rientro_rete" && item.log_type!="vuoto" && item.log_type!="report_illuminazione")
            //         emergency_type=true;
            //     else if (item!=null && item.log_type=="report_illuminazione" && item.log_lamps.length>0)
            //         lighting_type=true;
            //     });
            //     if(emergency_type==true && lighting_type==true)
            //       return true;
            //     else if(emergency_type==true && lighting_type==false)
            //     {
            //         this.tipoDispositivo="emergenza";
            //         return false;
            //     }
            //     else
            //     {
            //         this.tipoDispositivo="illuminazione";
            //         return false;
            //     }
            // }
        // },
        //calcola il numero di errori di una dispositivo Sicuro
        calcolaNumErrori(disp)
        {
            let num = 0;
            for (const property in disp)
            {
                if ((property.includes("error")) && (disp[property] === "ON"))
                {
                    num++;
                }
            }
            return num;
        },

        //restituisce la class 'circle ok/err' a seconda che ci sia o meno un errore
        dotClassLineLog(line) {
            var stato_line=null;
            //console.log("errori nel logbook",value);
            if(this.calcolaNumErrori(line) === 0)
            {
                stato_line = "fa-check-circle check-ok";
            }
            else {
                stato_line = "fa-exclamation-circle check-err";
            }
            return stato_line;
        },

        //restituisce la class 'circle ok/err' a seconda che ci sia o meno un errore
        dotClassCentralLog(cent) {
            //console.log("errori nel logbook",value);
            if(this.calcolaNumErrori(cent) === 0)
            {
                return "fa-check-circle check-ok";
            }
            else {
                return "fa-exclamation-circle check-err";
            }
        },

        async loadGlobalReports() {
            var reply = await this.$store.dispatch('loadGlobalReports',this.plantId);
            console.log("load global reports result:",reply);
            if (reply != null && reply.data != null) {
                this.globalReports = reply.data;
            }
        },
        // getListCu(logbook)
        // {
        //     var string_logbook="";
        //     for(var i=0;i<logbook.length;i++)
        //     {
        //         string_logbook=string_logbook+logbook[i].log_system + " " + logbook[i].cu_id + "<BR>";
        //     }
        //     return string_logbook;
        // },
        logbookUnits(cu_id) {
            var period=this.funct_graph_time;
            var allLogbook=this.tableDataLogbook.filter(function(item)
            {
                //report funzionali del periodo selezionato (mese, anni, da inizio impianto)
                return (item.cu_id==cu_id && ((Date.now()/1000 - item.log_timestamp)/3600/24)<period)
            });
            return allLogbook;
        },
        // logbookAutoUnits(cu_id) {
        //     var period=this.auto_graph_time;
        //     var autoLogbook=this.tableDataLogbook.filter(function(item)
        //     {
        //         return (item.log_type=="test_autonomia_automatico" && item.cu_id==cu_id && ((Date.now()/1000 - item.log_timestamp)/3600/24)<period)
        //     });
        //     return autoLogbook;
        // },
        // passaAPro() {
        //      this.$router.push({
        //         name: "GeneraliImpianto",
        //         params: { plantId: this.$store.state.currentPlant.id }
        //     });
        // },
        lampDet(idlamp) {
            var lamp = {}
            if (this.$store.state.plantUnits == null) return {}
            this.$store.state.plantUnits.forEach(function(u) {
                if (self.tipoDispositivo=="emergenza")
                {
                    u.lamps.forEach(function(l) {
                        if (l.id == idlamp) lamp = l;
                    })
                }
                else
                {
                    u.lamps_illum.forEach(function(l) {
                        if (l.id == idlamp) lamp = l;
                    })
                }
            })
            return lamp;
        },

        //ricerca la lampada con id=idLamp in $store.state.plantUnits e la restituisce
        lampSicuroDet(idLamp)
        {
            if (this.$store.state.plantUnits == null) return {}
            //trovo la lampada in plantUnits
            var lampDet = null;
            var continua = true; //quando viene posto a false, fa uscire dai cicli every
            this.$store.state.plantUnits.filter( (c) => c.cu_type === 'sicuro').every( (u) => {
                u.ak.every( (a) => { //comincio con gli ak
                    a.lines.every( (l) => {
                        l.lamps.every( (la) => {
                            if (la.lamp_id == idLamp) {
                                lampDet = la;
                                continua = false;
                            }
                            return continua;
                        });
                        return continua;
                    });
                    return continua;
                });
                if (continua) { //continuo con gli ak_ext
                    u.ak_ext.every( (a) => {
                        a.lines.every( (l) => {
                            l.lamps.every( (la) => {
                                if (la.lamp_id == idLamp) {
                                    lampDet = la;
                                    continua = false;
                                }
                                return continua;
                            });
                            return continua;
                        });
                        return continua;
                    });
                }
                return continua;
            });
            return lampDet;
        },

        //restituisce un array con gli snapshot per il report in pdf
        getLastLogbook(self,logbooks)
        {
            var logbook_rows = [];

            logbooks.filter(function(item)
            {
                //rows item for snapshot report in pdf
                item.log_cu_id=(item.log_system + " - " + item.cu_id).toUpperCase();
                item.report_date?item.log_date_format=self.dataRep(item.report_date).data + " " + self.dataRep(item.report_date).ora:"";
                item.log_type =  item.report_type? self.$t('report_table.'+item.report_type):"";

                if(item.report_result)
                {
                    if (item.report_result !== "fail") {
                        if (item.report_type=='test_funzionale_automatico' && item.log_lamps.some((el) => el.error_batt_test_auto=='ON'))
                        {
                            item.log_esito=self.$t("report_table.error_auto_in_funct");
                        }
                        else
                        {
                            item.log_esito=item.report_result.toUpperCase();
                        }
                    } else {
                        item.log_esito=item.report_result.toUpperCase();
                    }
                }
                else
                {
                    item.log_esito="NOT EXECUTED";
                }

                self.$store.state.plantUnits.forEach(function(u) {
                    if(item.log_system==u.cu_type && item.cu_id==u.cu_id)
                        item.log_cu_desc=u.cu_desc;
                                    });

                logbook_rows.push(item);
            });

            return logbook_rows;
        },

        getLinesWithErrorInLogbook(self, logbooks)  {

            var line_rows=[];

            console.log("getLinesWithErrorInLogbook LOGBOOK: ", logbooks);
            logbooks.forEach(function(log)  {
                const cu = log.log_system + '-' + log.cu_id
                if (log.log_system.toLowerCase() == 'sicuro') {
                    if (log.log_lines && (log.log_lines.length > 0)) {
                        log.log_lines.forEach( (line) => {
                            const erroriLine = self.getErroriLines(line);
                            if (erroriLine.length > 0) {
                                line_rows.push({ index: line.line_num, ak: line.ak, tipo: self.$t('report_pdf.ak_int'), centrale: cu, errori: erroriLine})
                            }
                        })
                    }
                    if (log.log_lines_ext && (log.log_lines_ext.length > 0)) {
                        log.log_lines_ext.forEach( (line) => {
                            const erroriLine = self.getErroriLines(line);
                            if (erroriLine.length > 0) {
                                line_rows.push({ index: line.line_num, ak: line.ak, tipo: self.$t('report_pdf.ak_ext'), centrale: cu, errori: erroriLine})
                            }
                        })
                    }
                }
            });
            return line_rows;
        },
        //Restituisce un array con le lampade in errore secondo gli ultimi logbook
        //si usa every() per scorrere un array perché se si ritorna 'false' si esce subito dal ciclo: in questo modo,
        //quando troviamo la lampada, usciamo e passiamo a quella successiva
        getLampsWithErrorInLogbook(self,logbooks)
        {

            var lamps_rows=[];
            var num_lamp_error=0;

            console.log("getLampsWithErrorInLogbook LOGBOOK: ", logbooks);
            logbooks.forEach(function(item)
            {
                //get lamps if isn't null item
                if(item && item.log_lamps)
                {
                    //get lamps with errors from logbook
                    item.log_lamps.forEach(function(lamp) {
                      //consideriamo solo le lampade attualmente presenti sull'impianto
                      if (self.lampsList.includes(lamp.id)) {
                          var cuName="";
                          var tipoLampada="n.d.";
                          var codeLampada="n.d.";
                          var descLampada="n.d.";
                          var batteryCode="n.d.";
                          var batteryDesc="n.d.";
                          var batteryQty="n.d.";
                          // var uvoxyCode="n.d.";
                          // var uvoxyDesc="n.d.";
                          // var uvoxyCode = "143926723"
                          // var uvoxyDesc = "CARTUCCIA UV-C";
                          //se il logbook è di tipo vecchio, senza i dati dei pezzi di ricambio, allora provo a trovare i dati nella shadow di centrale
                          //per fare questa verifica, utilizzo 'product_desc' ed 'order_code' comuni a tutti i tipi di lampada
                          if ((lamp.product_desc === null || lamp.product_desc === undefined || lamp.product_desc === "") && (lamp.order_code === null || lamp.order_code === undefined || lamp.order_code === "")) {
                              //trovo la lampada nella shadow di centrale
                              var lampDet = null;
                              self.$store.state.plantUnits.every( (u) => {
                                  var trovato = false;
                                  if (self.tipoDispositivo == "emergenza") {
                                      if (u.cu_type === "sicuro") {
                                          u.ak.every( (ak) => {
                                              ak.lines.every( (line) => {
                                                  line.lamps.every( (l) => {
                                                      if (l.lamp_id == lamp.id)
                                                      {
                                                          lampDet = l;
                                                          cuName = u.cu_type + "-" + u.cu_id;
                                                          trovato = true;
                                                      }
                                                      return !trovato;
                                                  });
                                                  return !trovato;
                                              });
                                              return !trovato;
                                          });
                                      } else { //logica, logicafm, cablecom
                                          u.lamps.every( (l) => {
                                              if (l.id == lamp.id)
                                              {
                                                  lampDet = l;
                                                  cuName=u.cu_type + "-" + u.cu_id;
                                                  trovato = true;
                                              }
                                              return !trovato;
                                          });
                                      }
                                  }
                                  else
                                  {
                                      u.lamps_illum.every( (l) => {
                                          if (l.id == lamp.id)
                                          {
                                              lampDet = l;
                                              cuName=u.cu_type + "-" + u.cu_id;
                                              trovato = true;
                                          }
                                          return !trovato;
                                      });
                                  }
                                  return !trovato;
                              });
                              if (lampDet!=null)
                              {
                                  tipoLampada = (lampDet.product_desc)?((lampDet.product_desc.includes('|'))?lampDet.product_desc.split('|')[0]:lampDet.product_desc):"n.d.";
                                  codeLampada = (lampDet.order_code)?lampDet.order_code:"n.d.";
                                  descLampada = lamp.descr;
                                  batteryCode = (lampDet.battery_code)?lampDet.battery_code:"n.d.";
                                  batteryDesc = (lampDet.battery_desc)?lampDet.battery_desc:"n.d.";
                                  batteryQty = (lampDet.battery_qty)?lampDet.battery_qty:"1";
                                  // uvoxyCode = (lampDet.uvoxy_code)?lampDet.uvoxy_code:"n.d.";
                                  // uvoxyDesc = (lampDet.uvoxy_desc)?lampDet.uvoxy_desc:"n.d.";
                              }
                              //se una lampada è presente nel logbook ma non è più nel sistema, avremmo un campo vuoto nella tabella, aggiungo allora i dati prendendoli
                              //dal logbook e aggiungo un asterisco * che segnala qualcosa di strano
                              if ("" === cuName) {
                                  cuName = item.log_system + '-' + item.cu_id + '*';
                              }
                          } else {
                              tipoLampada = (lamp.product_desc.includes('|'))?lamp.product_desc.split('|')[0]:lamp.product_desc;
                              codeLampada = lamp.order_code;
                              descLampada = lamp.descr;
                              batteryCode = (lamp.battery_code)?lamp.battery_code:"n.d.";
                              batteryDesc = (lamp.battery_desc)?lamp.battery_desc:"n.d.";
                              batteryQty = (lamp.battery_qty)?lamp.battery_qty:"1";
                              // uvoxyCode = (lamp.uvoxy_code)?lamp.uvoxy_code:"n.d.";
                              // uvoxyDesc = (lamp.uvoxy_desc)?lamp.uvoxy_desc:"n.d.";
                              cuName = item.log_system + '-' + item.cu_id;
                          }

                          var esito = "Pass";

                          //return string errore lamp in report
                          let {errorType: error_type, errorText: error_text} = self.getErroriLamp(self, lamp);

                          if (error_type.length > 0) {
                              esito = "Fail";
                              num_lamp_error++;
                              lamps_rows.push({
                                  index:"["+num_lamp_error+"]",
                                  id: lamp.id, desc: descLampada,
                                  tipo: tipoLampada,
                                  code: codeLampada,
                                  battery_code: batteryCode,
                                  battery_desc: batteryDesc,
                                  battery_qty: batteryQty,
                                  // uvoxy_code: uvoxyCode,
                                  // uvoxy_desc: uvoxyDesc,
                                  cuName: cuName,
                                  esito: esito,
                                  errori: error_text,
                                  errore_type: error_type,
                                  notes: lamp.note,
                                  lamp_raw: lamp,
                                  report_date: item.log_date_format,
                                  report_type: item.log_type
                              });
                          }
                      }
                    })
                }
            })
            console.log("lamps_rows: ", lamps_rows);
            return lamps_rows;
        },

        //Restituisce un oggetto con l'errore prioritario e la sua traduzione nelle diverse lingue
        getErroriLamp(self, lamp)
        {
            let errorText="";
            let errorType="";

            //helper function
            const setError = (err, texterr) => {
                errorType = err,
                errorText = texterr;
            };
            //Logica, LogicaFM
            if ((lamp.nodo_orfano == true) || (lamp.error_com == 'ON' && lamp.error_hardware == 'ON' && lamp.error_batt_short == 'ON' && lamp.error_led == 'ON' && lamp.error_tubo_UV =='ON'))
                setError("lamp_orphan_error", self.$t("details_lamp.lamp_orphan_error"));
            else if (lamp.error_com == 'ON' && lamp.error_hardware == 'OFF')
                setError("lamp_error_com", self.$t("details_lamp.lamp_error_com"));
            else if(lamp.error_comm_radio_lamp == "ON" || (lamp.error_com == 'ON' && lamp.error_hardware == 'ON' && lamp.error_batt_short == 'OFF' && lamp.error_led == 'OFF' && lamp.error_batt_test_funz == 'OFF'))
                setError("lamp_error_comm_radio_lamp", self.$t("details_lamp.lamp_error_comm_radio_lamp"));
            else if (lamp.error_hardware == 'ON')
                setError("lamp_error_hardware", self.$t("details_lamp.lamp_error_hardware"));
            else if (lamp.error_led == 'ON')
                setError("lamp_error_led", self.$t("details_lamp.lamp_error_led"));
            else if (lamp.error_batt_short == 'ON')
                setError("lamp_error_batt_short", self.$t("details_lamp.lamp_error_batt_short"));
            //check errori batteria durante il test
            else if (lamp.error_batt_test_funz == 'ON')
                setError("lamp_error_batt_test_funz", self.$t("details_lamp.lamp_error_batt_test_funz"));
            else if (lamp.error_batt_test_auto == 'ON')
            {
                let txt = self.$t("details_lamp.lamp_error_batt_test_auto");

                if (lamp.residual_time)
                {
                    const min = parseInt(lamp.residual_time.split('min.')[0]);
                    if (min < 60 && min != 0)
                        txt += " (" + self.$t("details_lamp.lamp_residual_time") + ": " + min + "min.)";
                    else if (min === 0)
                        txt += " ("+self.$t("details_lamp.lamp_residual_time") + ": " + "< 4 min.)";
                    else
                        txt += " ("+self.$t("details_lamp.lamp_residual_time") + ": " + "----";
                }
                if(lamp.error_ricarica_incompleta=="ON")
                {
                    txt += " (" + self.$t("details_lamp.lamp_error_ric_incompleta") + ")";
                }
                setError("lamp_error_batt_test_auto", txt);
            }
            else if (lamp.error_tubo_UV == 'ON')
                setError("lamp_error_tubo_UV", self.$t("details_lamp.lamp_error_tubo_UV"));
            else if (lamp.error_underpower =="ON")
                setError("lamp_error_underpower", self.$t("details_lamp.lamp_error_underpower"));
            else if (lamp.error_undervoltage =="ON")
                setError("lamp_error_undervoltage", self.$t("details_lamp.lamp_error_undervoltage"));
            else if (lamp.error_overpower == "ON")
                setError("lamp_error_overpower", self.$t("details_lamp.lamp_error_overpower"));
            else if (lamp.error_overvoltage == "ON")
                setError("lamp_error_overvoltage", self.$t("details_lamp.lamp_error_overvoltage"));

            //SICURO: comunication AK e fuse sono prioritari
            if (lamp.error_com_ak_lamp === 'ON')
                setError("lamp_error_com_ak_lamp", self.$t("details_lamp.lamp_error_com_ak_lamp"));
            else if (lamp.error_line_fuse === 'ON')
                setError("lamp_error_line_fuse", self.$t("details_lamp.lamp_error_line_fuse"));
            else if (lamp.error_led_full_short === 'ON')
                setError("lamp_error_led_full_short", self.$t("details_lamp.lamp_error_led_full_short"));
            else if (lamp.error_led_open === 'ON')
                setError("lamp_error_led_open", self.$t("details_lamp.lamp_error_led_open"));
            else if (lamp.error_led_partial_short === 'ON')
                setError("lamp_error_led_partial_short", self.$t("details_lamp.lamp_error_led_partial_short"));
            else if (lamp.error_dali_com === 'ON')
                setError("lamp_error_dali_com", self.$t("details_lamp.lamp_error_dali_com"));
            else if (lamp.error_dali_hardware === 'ON')
                setError("lamp_error_dali_hardware", self.$t("details_lamp.lamp_error_dali_hardware"));
            else if (lamp.error_dali_lamp === 'ON')
                setError("lamp_error_dali_lamp", self.$t("details_lamp.lamp_error_dali_lamp"));
            else if (lamp.error_low_voltage === 'ON')
                setError("lamp_error_low_voltage", self.$t("details_lamp.lamp_error_low_voltage"));
            else if (lamp.error_polarity_reverse === 'ON')
                setError("lamp_error_polarity_reverse", self.$t("details_lamp.lamp_error_reverse_polarity"));
            else if (lamp.error_under_threshold === 'ON')
                setError("lamp_error_under_threshold", self.$t("details_lamp.lamp_error_under_threshold"));
            else if (lamp.error_lamp_programming === 'ON')
                setError("lamp_error_lamp_programming", self.$t("details_lamp.lamp_error_programming"));
            else if (lamp.error_id_duplicate === 'ON')
                setError("lamp_error_id_duplicate", self.$t("details_lamp.lamp_error_duplicate"));

            //console.log("list errori" , errori);
            return {
                errorType,
                errorText
            }
        },

        getErroriCentrale(e)
        {
            var errori="";

            if (e.error_ak_o_luci == 'ON') errori +=", " + this.$t("details_cent.error_ak_o_luci");
            if (e.error_all_chargers_or_fuse == 'ON') errori +=", " + this.$t("details_cent.error_all_chargers_or_fuse");
            if (e.error_autonomy_test == 'ON') errori +=", " + this.$t("details_cent.error_autonomy_test");
            if (e.error_battery_fuse == 'ON') errori +=", " + this.$t("details_cent.error_battery_fuse");
            if (e.error_battery_low == 'ON') errori += ", " + this.$t("details_cent.error_battery_low");
            if (e.error_battery_simmetry == 'ON') errori += ", " + this.$t("details_cent.error_battery_simmetry");
            if (e.error_battery_temperature == 'ON') errori += ", " + this.$t("details_cent.error_battery_temperature");
            if (e.error_cabinet_isominus == 'ON') errori += ", " + this.$t("details_cent.error_cabinet_isominus");
            if (e.error_cabinet_isoplus == 'ON') errori += ", " + this.$t("details_cent.error_cabinet_isoplus");
            if (e.error_chargers == 'ON') errori += ", " + this.$t("details_cent.error_chargers");
            if (e.error_com_cpu_ak == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_ak");
            if (e.error_com_cpu_charger == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_charger");
            if (e.error_com_cpu_io == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_io");
            if (e.error_com_cpu_lssa == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_lssa");
            if (e.error_com_cpu_substation == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_substation");
            if (e.error_com_cpu_switch11kw == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_switch11kw");
            if (e.error_functional_test == 'ON') errori += ", " + this.$t("details_cent.error_functional_test");
            if (e.error_general == 'ON') errori += ", " + this.$t("details_cent.error_general");
            if (e.error_io_measures == 'ON') errori += ", " + this.$t("details_cent.error_io_measures");
            if (e.error_lamp_programming == 'ON') errori += ", " + this.$t("details_cent.error_lamp_programming");
            if (e.error_line_isolation == 'ON') errori += ", " + this.$t("details_cent.error_line_isolation");
            if (e.error_swap_lampade == 'ON') errori += ", " + this.$t("details_cent.error_swap_lampade");
            if (e.no_critical_circuit == 'ON') errori += ", " + this.$t("details_cent.no_critical_circuit");
            if (e.no_mains == 'ON') errori += ", " + this.$t("details_cent.no_mains");
            if (e.no_phase1 == 'ON') errori += ", " + this.$t("details_cent.no_phase1");
            if (e.no_phase2 == 'ON') errori += ", " + this.$t("details_cent.no_phase2");
            if (e.no_phase3 == 'ON') errori += ", " + this.$t("details_cent.no_phase3");
            if (e.no_subdistribution == 'ON') errori += ", " + this.$t("details_cent.no_subdistribution");
            if (e.system_inhibited == 'ON') errori += ", " + this.$t("details_cent.system_inhibited");
            if (e.warning_charger_off_by_temperature == 'ON') errori += ", " + this.$t("details_cent.warning_charger_off_by_temperature");
            if (e.warning_maintenance == 'ON') errori += ", " + this.$t("details_cent.warning_maintenance");

            console.log("list errori SICURO: " , errori);
            return errori;
        },

        getErroriLines(l)
        {
            var errori="";
            //check errori hardware, led, com, batt_short
            if (l.error_com_cpu_ak == 'ON') errori +=" " + this.$t("details_line.error_com");
            if (l.error_ak_su_current == 'ON') errori +=" " + this.$t("details_line.error_current");
            if (l.error_line_fuse == 'ON') errori +=" " + this.$t("details_line.error_fuse");
            if (l.error_line_isolation == 'ON') errori +=" " + this.$t("details_line.error_isolation");
            return errori;
        },

        getLogbookNote(idLamp){
            // si chiama cosi la prop id nel logbook?
            var currentLogBook=this.$store.state.currentLogbooks.filter(function(item)
            {
                return (item.id == idLamp)
            });
            return currentLogBook.note;
        },
        editNote(log_timestamp, cu_id, lamp ){
            //this.selectedLampNote = lampNote;
            //this.isNoteEditable = true;
            this.editingNoteId = log_timestamp + '_' + cu_id +'_' + lamp.id;
            this.editingLampNote = lamp.note;
        },
        abortNoteLamp() {
            //this.isNoteEditable = false;
            this.editingNoteId = '';
            this.editingLampNote = '';
        },
        async saveNoteLamp(log_timestamp, cu_id, lamp) {
          // this.$store.dispatch("dbSaveLampNote", lampada con nota);
          //this.updatingName = true;
          var note = ''+this.editingLampNote.trim();

          try {
              var esito = await this.$store.dispatch("aggiornaNoteLogbook", {log_timestamp: log_timestamp, cu_id: cu_id, lamp_id: lamp.id, note: note});
              console.log("esito salvataggio note:",esito);
              if (esito.error == null) {
                lamp.note = note;
                this.editingNoteId = '';
                this.editingLampNote = '';
              } else {
                  this.$bvModal.msgBoxOk("Si è verificato un problema durante il salvataggio delle note\n" +esito.error);
              }

          } catch (err) {
              console.log("errore in salvataggio!", err);
              this.$bvModal.msgBoxOk("Si è verificato un problema durante il salvataggio delle note\n" + err);
          }
          // TODO -> fare funzione per quando riceve risposta dal server e imposta updatingName = false
        },
        dataRep(ts) {
            var d = new Date(ts*1000);
            var data = d.getDate() + "/" + (d.getMonth()+1) + "/" + d.getFullYear();
            var h = "0" + d.getHours();
            var m = "0" + d.getMinutes();
            var s = "0" + d.getSeconds();
            var ora =  h.substring(h.length-2) + ":" + m.substring(m.length-2) + ":" + s.substring(s.length-2);
            return  {data: data, ora: ora};
        },

        // closeCentDetails() {
        //     this.currentCent = null;
        // },
        // dotClassCentLog(value) {

        //    var stato_log=null;
        //    if(value === "pass")
        //    {
        //       stato_log = "fa-check-circle check-ok";
        //    }
        //    else
        //    {
        //       stato_log = "fa-exclamation-circle check-err";
        //    }
        //     return stato_log
        // },
        //restituisce la class circle ok/err a seconda che ci sia o meno un errore
        dotClassLog(lamp) {
            let self=this;
            var stato_lamp=null;
            //console.log("errori nel logbook",value);
            if(this.getErroriLamp(self, lamp).errorText === "")
            {
                stato_lamp = "fa-check-circle check-ok";
            }
            else {
                stato_lamp = "fa-exclamation-circle check-err";
            }
            return stato_lamp
        },
        descClassLog(lamp) {
           let self=this;
           var error= this.getErroriLamp(self, lamp).errorText;
           error=error.replace(",","");
           return error
        },
        descClassLogType(value) {
           return this.$t("report_table."+ value);
        },
        // formatDate(date) {
        //     var d = new Date(date),
        //     month = '' + (d.getMonth() + 1),
        //     day = '' + d.getDate(),
        //     year = d.getFullYear();

        //     if (month.length < 2)
        //         month = '0' + month;
        //     if (day.length < 2)
        //         day = '0' + day;

        //     return [year, month, day].join('-');
        // },

        //Report eventi di rete
        // createPDF_Mains ()
        // {
        //     //Set heading for pdf table
        //     var columns = [
        //         {title: "Data", dataKey: "log_date_format"},
        //         {title: "Centrale", dataKey: "cu_id"},
        //         {title: "Evento", dataKey: "log_type_descr"}];
        //     var rows = [];

        //     var self = this;

        //     //Create date format
        //     var dateObj;
        //     var format_date;

        //     var pdfMains=this.tableDataMains.filter(function(item)
        //     {
        //         dateObj = new Date(item.log_timestamp * 1000);
        //         item.log_date_format=dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();
        //         item.log_type_descr =  self.$t('report_table.'+item.log_type)
        //         rows.push(item);
        //     })

        //     console.log("ROW REPORT",rows);

        //     //Define header and table name
        //     let header= this.$t("report_pdf.header_mains");
        //     let plant_header=this.plantDetails.plantname.replaceAll(".","");
        //     var date_now = new Date();
        //     let table_name=this.$t("report_pdf.table_name_mains")+plant_header;


        //     // Only pt supported (not mm or in)
        //     var doc = new jsPDF('p', 'pt');
        //     doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
        //     doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
        //     doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
        //     doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

        //     var margin_top=0;
        //     doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
        //     doc.setFont("Roboto");
        //     doc.setFontType("normal");
        //     doc.setFontSize(10);
        //     doc.text(self.$t('report_pdf.title_impianto') + " : " +  this.plantDetails.plantname,38,70);
        //     doc.text(self.$t('report_pdf.title_create_date') + " : " + date_now.toLocaleDateString() + date_now.toLocaleTimeString(),38,90);
        //     doc.text(header,38,120);

        //     doc.autoTable(columns, rows, {
        //         startY: 135,
        //         theme: 'striped'
        //     });
        //     doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2), doc.internal.pageSize.height - 40, 70, 20);
        //     doc.save(table_name);
        // },

        async getImageData(logo) {
            logo.crossOrigin="anonymous";
            await logo.decode();
            console.log("immagine:" + logo.width + "x" + logo.height ,logo);
            var canvas = document.createElement("canvas");
            canvas.width = logo.width;
            canvas.height = logo.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(logo, 0, 0);
            var dataURL = canvas.toDataURL("image/png");
            //console.log("logo dataurl:" + dataURL);
            return dataURL;
        },
        //--------------------------------------------------------------------
        // Fornisce la lista di tutti i logbook
        //--------------------------------------------------------------------
        async createPDF_List_Logbook ()
        {
            var rows = [];
            var self = this;

            //Set heading for pdf table
            var columns = [
                {title: self.$t('report_pdf.title_data'), dataKey: "log_date_format"},
                {title: self.$t('report_pdf.title_centrale'), dataKey: "cu_id"},
                {title: self.$t('report_pdf.title_tipologia'), dataKey: "log_system"},
                {title: self.$t('report_pdf.title_evento'), dataKey: "log_type_descr"},
                {title: self.$t('report_pdf.title_stato'), dataKey: "log_esito"}];

            //Create date format
            var dateObj;
            var format_date;

            var pdfListLogbook=this.tableDataLogbook.filter(function(item)
            {
                if(item.log_esito=="pass" && item.log_type=='test_funzionale_automatico' && item.log_lamps.some((el) => el.error_batt_test_auto=='ON'))
                    item.log_esito=self.$t('report_table.error_auto_in_funct');
                dateObj = new Date(item.log_timestamp * 1000);
                item.log_date_format=dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString();
                item.log_type_descr =  self.$t('report_table.'+item.log_type)
                rows.push(item);
            })

            //Define header and table name
            let header= this.$t("report_pdf.header_logbook");
            let plant_header=this.plantDetails.plantname.replaceAll(".","");
            var date_now = new Date();
            let table_name=this.$t("report_pdf.table_name_logbook")+plant_header;

            // Only pt supported (not mm or in)
            //var doc = new jsPDF('p', 'pt');
            const doc = new jsPDF({
                orientation: 'p',
                unit: 'pt',
                format: 'a4',
                putOnlyUsedFonts: true,
                floatPrecision: 16
            });

            doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
            doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
            doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
            doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');
            //var logo = new Image();

            // //QUELLO FISSO FUNZIONA, L'ALTRO INVECE DA ERRORE CORS
            // logo.src = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id="+this.plantDetails.id+"&rnd=" + Math.random();
            // console.log("LOGO.SRC: ", logo.src);
            // logo.src = 'https://7zjf09bmo8.execute-api.eu-west-1.amazonaws.com/Dev?action=getResource&type=logo&id=b6b6b79c-614b-470b-af82-f35ee2e1efb1&rnd=0.08225847950571219';
            // var logoData = await this.getImageData(logo);
            // //console.log("logodata:", logoData);
            // var logoAspect = logo.width / logo.height;
            // var lw = 40 * logoAspect;
            // doc.addImage(logoData, 'PNG', 38, 15, lw, 40);

            //Inserimento del logo come intestazione al PDF
            if (this.plantDetails.logoId != null) {
                console.log("Esiste il logo!");
                let logoUrl = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id="+this.plantDetails.id+"&rnd=" + Math.random();
                var logoImg = new Image();
                logoImg.src = logoUrl;
                var logoData = await this.getImageData(logoImg);
                var w = 60 * logoImg.width / logoImg.height;
                //var x = (doc.internal.pageSize.getWidth() - w ) / 2;
                doc.addImage(logoData, 'PNG', 38, 15, w, 60);
            } else {
                doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
            }


            doc.setFont("Roboto", 'normal');
            //doc.setFontType("normal");
            doc.setFontSize(10);
            doc.text(self.$t('report_pdf.title_impianto') + " : " +  this.plantDetails.plantname,38,90);
            doc.text(self.$t('report_pdf.title_create_date') + " : " + date_now.toLocaleDateString() + date_now.toLocaleTimeString(),38,105);
            doc.text(header,38,120);

            //L'inizializzazione seguente è deprecata
            // doc.autoTable(columns, rows, {
            //     startY: 140,
            //     theme: 'striped'
            // });
            doc.autoTable({
                columns: columns,
                body: rows,
                startY: 140,
                theme: 'striped',
                headStyles: {
                    font: 'Roboto',
                },
                styles: {
                    font: 'Roboto',
                },
            });
            doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2), doc.internal.pageSize.height - 40, 70, 20);
            doc.save(table_name);
        },

        //----------------------------------------------------
        // Crea un pdf con:
        // una tabella che contiene gli ultimi logbook,
        // una tabella con le linee in errore,
        // una tabella con le lampade in errore,
        // una tabella con le soluzioni proposte,
        // una tabella con i codici dei pezzi di ricambio
        //----------------------------------------------------
        async createPDF_Snapshot()
        {
            const self = this;

            //Strutturadi erro_solution_rows
            self.error_solution_rows=[];
            self.error_spare_parts=[];

            //Set heading for logbook pdf table
            var columnsHeadings = [
                {title: self.$t('graph.report_date'), dataKey: "log_date_format"},
                {title: self.$t('report_table.log_type'), dataKey: "log_type"},
                {title: self.$t('report_pdf.cu_desc'), dataKey: "log_cu_desc"},
                {title: self.$t('report_pdf.reference_cu'), dataKey: "log_cu_id"},
                {title: self.$t('report_pdf.title_esito_lamp'), dataKey: "log_esito"}];

            var rowsLastLB = [];

            //Fill row with data from snapshot
            var logbook_snapshot= this.reportCentData;

            //get list of last logbooks for pdf print
            rowsLastLB=this.getLastLogbook(self,logbook_snapshot);
            console.log("createPDF_Snapshot: FUNCTION ROWS FROM GET LAST LOGBOOK",rowsLastLB);

            //get list of lamps with errors for donut error lamps type and download pdf
            self.lamps_rows=this.getLampsWithErrorInLogbook(self,rowsLastLB);
            console.log("FUNCTION LAMPS ROWS FROM GET LAMPS WITH ERRORS",self.lamps_rows);

            const line_error = this.getLinesWithErrorInLogbook(self,rowsLastLB);
            var columnsLN = [
                {title: self.$t('report_pdf.title_centrale'), dataKey: "centrale"},
                {title: self.$t('report_pdf.title_ak'), dataKey: "ak"},
                {title: self.$t('report_pdf.title_index'), dataKey: "index"},
                {title: self.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"},
                {title: self.$t('report_pdf.title_error_lamp'), dataKey: "errori"},
            ];

            //Create var
            var num_lamp_error=0;
            //Struttura di spare_part_array
            //spare_part_array = [{code: "415393001", desc: "Battery 12V 4Ah"}, {code: "435393000", desc: "UV-OXY Tube"}, ecc];
            var spare_part_array=[];
            var error_spare_parts=false;
            var spare_part_item={};

            //rows item for lamps with errors
            self.lamps_rows.forEach(function(lamp) {

                num_lamp_error++;
                console.log("LAMP WITH ERRORS ",lamp.id + " Errors: " + lamp.errori);

                var solution="";

                //check for error battery BOM
                //if(lamp.lamp_raw.error_batt_test_funz =='ON'|| lamp.lamp_raw.error_batt_short =='ON'){
                if (lamp.errore_type === 'lamp_error_batt_test_funz' || lamp.errore_type === 'lamp_error_batt_short') {
                    solution=self.$t("report_pdf.change_battery")
                    error_spare_parts=true;
                    spare_part_item={};
                    spare_part_item.code=lamp.battery_code;
                    spare_part_item.desc=lamp.battery_desc;
                    spare_part_item.qty=lamp?.battery_qty;
                    console.log("1 error batt test funz, lamp: ", lamp, " spare_part_item: ", spare_part_item);
                    spare_part_array.push(spare_part_item);
                }
                //check for error battery BOM
                //else if(lamp.lamp_raw.error_batt_test_auto =='ON' && lamp.lamp_raw.error_ricarica_incompleta =='OFF'){
                else if (lamp.errore_type === 'lamp_error_batt_test_auto' && lamp.lamp_raw.error_ricarica_incompleta =='OFF') {
                    solution=self.$t("report_pdf.change_battery")
                    error_spare_parts=true;
                    spare_part_item={};
                    spare_part_item.code=lamp.battery_code;
                    spare_part_item.desc=lamp.battery_desc;
                    spare_part_item.qty=lamp?.battery_qty;
                    console.log("2 error batt test funz, lamp: ", lamp, " spare_part_item: ", spare_part_item);
                    spare_part_array.push(spare_part_item);
                }
                //check for error uvoxy BOM
                //if(lamp.lamp_raw.error_tubo_UV =='ON'){
                if (lamp.errore_type === 'lamp_error_tubo_UV') {
                    solution=self.$t("report_pdf.change_uvoxy")
                    error_spare_parts=true;
                    spare_part_item={};
                    //spare_part_item.code=lamp.uvoxy_code;
                    //spare_part_item.desc=(lamp.uvoxy_desc!="" && lamp.uvoxy_desc!="n.d.")?lamp.uvoxy_desc:self.$t("details_lamp.uvoxy_desc");
                    spare_part_item.code = "143926723";
                    spare_part_item.desc="CARTUCCIA UV-C";
                    spare_part_array.push(spare_part_item);
                }
                // if(lamp.lamp_raw.error_com =='ON' || lamp.lamp_raw.error_hardware =='ON' || lamp.lamp_raw.error_led =='ON'
                //     || lamp.lamp_raw.error_overvoltage =='ON' || lamp.lamp_raw.error_overpower =='ON' || lamp.lamp_raw.error_undervoltage =='ON'
                //     || lamp.lamp_raw.error_underpower =='ON'  || lamp.lamp_raw.error_comm_radio_lamp =='ON')
                //     {
                if (lamp.errore_type === 'lamp_error_com' || lamp.errore_type === 'lamp_error_hardware' || lamp.errore_type === 'lamp_error_led'
                    || lamp.errore_type === 'lamp_error_overvoltage' || lamp.errore_type === 'lamp_error_overpower' || lamp.errore_type === 'lamp_error_undervoltage'
                    || lamp.errore_type === 'lamp_error_underpower'  || lamp.errore_type === 'lamp_error_comm_radio_lamp')
                {
                    solution=self.$t("report_pdf.check_hardware")
                }

                if(solution !="")
                    self.error_solution_rows.push({id: lamp.id, desc: lamp.desc, lamp_error: lamp.errori, error_solution: solution, spare_parts_code: (solution==self.$t("report_pdf.check_hardware"))?"--":spare_part_item.code, spare_parts_desc: (solution==self.$t("report_pdf.check_hardware"))?"--":spare_part_item.desc});

            })

            self.spare_parts_bom_rows = [];
            if(spare_part_array.length>0)
            {
                console.log("Spare part array before occ.", spare_part_array);
                var spare_part_occurency=this.findBattOccurences(spare_part_array,"code");
                console.log("Spare parts occ.", spare_part_occurency);
                for (var k=0;k<spare_part_occurency.length;k++)
                {
                    self.spare_parts_bom_rows.push({bom_quantity:spare_part_occurency[k].occurrence,bom_code:spare_part_occurency[k].code,bom_desc:spare_part_occurency[k].desc});
                }
                console.log("spare parts array", self.spare_parts_bom_rows);

            }

            //Define table name
            let plant_header=this.plantDetails.plantname.replaceAll(".","");
            let table_name=this.$t("report_pdf.table_name_logbook")+plant_header;

            // Only pt supported (not mm or in)
            //var doc = new jsPDF('p', 'pt');

            const doc = new jsPDF({
                orientation: 'p',
                unit: 'pt',
                format: 'a4',
                putOnlyUsedFonts: true,
                floatPrecision: 16
            });

            doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
            doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
            // Use 'Identity-H' encoding for the font registration to enable Unicode support
            doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
            doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

            doc.setFont('Roboto', 'bold');
            doc.setFontSize(12);

            var date_now = new Date();
            var dot = new Image();

            //Inserimento del logo come intestazione al PDF
            if (this.plantDetails.logoId != null) {
                console.log("Esiste il logo!");
                let logoUrl = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id="+this.plantDetails.id+"&rnd=" + Math.random();
                var logoImg = new Image();
                logoImg.src = logoUrl;
                var logoData = await this.getImageData(logoImg);
                var w = 60 * logoImg.width / logoImg.height;
                //var x = (doc.internal.pageSize.getWidth() - w ) / 2;
                doc.addImage(logoData, 'PNG', 38, 15, w, 60);

            } else {
                doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
            }

            //Inserimento dati impianto in pdf
            doc.text(self.$t('report_pdf.title_impianto') + " : " +  this.plantDetails.plantname,38,95);
            doc.setFont('Roboto', 'normal');
            doc.setFontSize(10);
            doc.text(this.plantDetails.address.street + " " + this.plantDetails.address.housenumber,38,110);
            doc.text(this.plantDetails.address.cap + " - " + this.plantDetails.address.city + " (" + this.plantDetails.address.prov +") " + this.plantDetails.address.country,38,125);
            doc.setFont('Roboto', 'bold');
            doc.setFontSize(14);

            doc.text(self.$t('report_table.title_logbook').toUpperCase(),38,200);
            //doc.text(self.$t('report_table.title_logbook'),38,200);
            //console.log(self.$t('report_table.title_logbook'));
            var period;
            if(self.auto_graph_time==7300) period=self.$t('report_pdf.from_installation')+" "+ date_now.toLocaleDateString() + " - " + date_now.toLocaleTimeString();
            if(self.auto_graph_time==365) period=self.$t('report_table.last_year');
            if(self.auto_graph_time==730) period=self.$t('report_table.last_2year');
            doc.setFont('Roboto', 'normal');
            doc.setFontSize(11);
            doc.text(self.$t('report_pdf.reference_period') + ": " + period, 38, 220);

            doc.setFontSize(12);


            //Lamp pass, fail, not executed
            dot.src = 'img/dot_ok.png';
            self.numLampReportPass>0? doc.addImage(dot, 'PNG', 38, 240, 10, 10):null;
            self.numLampReportPass>0? doc.text("N. " + self.numLampReportPass+" "+self.$t("graph.report_lamp_pass"),60,250):"";
            dot.src = 'img/dot_err.png';
            self.numLampReportFail>0? doc.addImage(dot, 'PNG', 38, 255, 10, 10):null;
            self.numLampReportFail>0? doc.text("N. " + self.numLampReportFail+" "+self.$t("graph.report_lamp_fail"),60,265):"";
            dot.src = 'img/dot_grey.png';
            self.numLampReportNotExecuted>0? doc.addImage(dot, 'PNG', 38, 270, 10, 10):null;
            self.numLampReportNotExecuted>0? doc.text("N. " + self.numLampReportNotExecuted+" "+self.$t("graph.report_lamp_not_executed"),60,280):"";
            // dot.src = 'img/dot_blu.png';
            // self.numLampReportFailUvoxy>0? doc.addImage(dot, 'PNG', 38, 270, 10, 10):null;
            // self.numLampReportFailUvoxy>0? doc.text("N. " + self.numLampReportFailUvoxy+" "+self.$t("graph.report_lamp_fail_uvoxy"),60,280):"";


            //Table report plant
            doc.autoTable({
                columns: columnsHeadings,
                body: rowsLastLB,
                headStyles: {
                    font: 'Roboto',
                    fontSize: 11,
                    fillColor : [59, 156, 204]
                },
                styles: {
                    font: 'Roboto',
                    fontSize: 10,
                },
                alternateRowStyles: {fillColor : [225, 238, 245]},
                tableLineColor: [59, 156, 204],
                tableLineWidth: 0.1,
                startY: 300
            });

            if (line_error.length > 0) {
                //---------------------------------------------
                // Page with lines with errors
                //---------------------------------------------
                doc.addPage();
                doc.setFont('Roboto', 'bold');
                doc.setFontSize(12);
                doc.text(self.$t('report_pdf.error_lines_title').toUpperCase(),38,60);
                doc.autoTable({
                    columns: columnsLN,
                    body: line_error,
                    headStyles: {
                        font: "Roboto",
                        fontSize: 11,
                        fillColor : [88, 106, 166]
                    },
                    styles: {
                        font: "Roboto",
                        fontSize: 10
                    },
                    alternateRowStyles: {fillColor : [210, 213, 220]},
                    startY: 80,
                    columnStyles: {
                        esito: {
                            font: "Roboto",
                            fontStyle: 'bold'
                        }
                    }
                });
            }

            //If lamps with errors are present
            if(self.lamps_rows.length>0)
            {
                //---------------------------------------------
                // Page with lamps with errors
                //---------------------------------------------
                doc.addPage();
                doc.setFont('Roboto', 'bold');
                doc.setFontSize(12);
                doc.text(self.$t('report_pdf.error_lamps_title').toUpperCase(),38,60);

                //Table report lamps with errors
                doc.autoTable({
                    columns: self.lamps_columns,
                    body: self.lamps_rows,
                    headStyles :{
                        font: 'Roboto',
                        fontSize: 11,
                        fillColor : [232, 76, 14]
                    },
                    styles: {
                        font: 'Roboto',
                        fontSize: 10,
                    },
                    alternateRowStyles: {fillColor : [250, 177, 125]},
                    tableLineColor: [232, 76, 14],
                    tableLineWidth: 0.1,
                    startY: 80
                });

                //---------------------------------------------
                // Page with errors solution
                //---------------------------------------------
                if(self.error_solution_rows.length >0)
                {
                    doc.addPage();
                    doc.setFont('Roboto', 'bold');
                    doc.setFontSize(12);
                    doc.text(self.$t('report_pdf.error_lamps_solution').toUpperCase(),38,60);

                    //Table solution
                        doc.autoTable({
                            columns: self.error_solution_columns,
                            body: self.error_solution_rows,
                            headStyles :{
                                font: 'Roboto',
                                fontSize: 11,
                                fillColor : [23, 122, 51]
                            },
                            styles: {
                                font: 'Roboto',
                                fontSize: 10,
                            },
                            alternateRowStyles: {fillColor : [185, 237, 200]},
                            tableLineColor: [23, 122, 51],
                            tableLineWidth: 0.1,
                            startY: 80
                        });
                }

                //---------------------------
                // Page with spare parts code
                //---------------------------
                if(spare_part_array.length>0)
                {
                    doc.addPage();
                    doc.setFont('Roboto', 'bold');
                    doc.setFontSize(12);
                    doc.text(self.$t('report_pdf.title_bom_battery').toUpperCase(),38,60);

                    //Table battery bom
                        doc.autoTable({
                            columns: self.spare_parts_bom_columns,
                            body:self.spare_parts_bom_rows,
                            headStyles :{
                                font: 'Roboto',
                                fontSize: 11,
                                fillColor : [6, 128, 18]
                            },
                            styles: {
                                font: 'Roboto',
                                fontSize: 10,
                            },
                            alternateRowStyles: {fillColor : [223, 252, 222]},
                            tableLineColor: [6, 128, 18],
                            tableLineWidth: 0.1,
                            startY: 80,
                            //theme: 'striped'
                        });
                }
            }

            if (this.numLampReportNotExecuted > 0) {
                //costruisco una tabella con gli id delle lampade che non hanno fatto il test
                doc.addPage();
                doc.setFont('Roboto', 'bold');
                doc.setFontSize(12);
                doc.text(self.$t('report_pdf.title_not_executed').toUpperCase(),38,60);

                let columnsNotExec = [
                    {title: this.$t('report_pdf.title_id_lamp'), dataKey: "id"},
                    {title: this.$t('report_pdf.title_desc_lamp'), dataKey: "desc"},
                    {title: this.$t('report_pdf.title_code_lamp'), dataKey: "code"},
                    {title: this.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"},
                    {title: this.$t('central_unit'), dataKey: "cuName"},
                ];
                let rowsNotExec = [];
                //cerco in tutte le centrali dell'impianto
                this.unitsDetails.forEach((unit) => {
                    //controllo ogni lampada di ogni centrale
                    if (unit.cu_type === 'sicuro') {
                        //cerco i logbook "NOT EXECUTED"
                        rowsLastLB.forEach((log) => {
                            if (log.log_esito === 'NOT EXECUTED' && log.cu_id === unit.cu_id) {
                                //se la centrale non ha fatto il test, tutte le sue lampade sono da considerare "not executed"
                                unit.ak.forEach((ak) => {
                                    ak.lines.forEach((line) => {
                                        line.lamps.forEach((lamp) => {
                                            rowsNotExec.push({id: lamp.lamp_id, desc: lamp.desc, code: lamp.order_code, tipo: (lamp.product_desc.includes('|') ? lamp.product_desc.split('|')[0] : lamp.product_desc), cuName: unit.cu_type + '-' + unit.cu_id});
                                        });
                                    });
                                });
                                return true; //esco dal ciclo some
                            } else return false;
                        });
                    } else {
                        unit.lamps.forEach((lamp) => {
                            var trovato = false;
                            //controllo ogni logbook
                            rowsLastLB.some((log) => {
                                //controllo ogni lampada del logbook
                                if (log.log_lamps) {
                                    log.log_lamps.some((lamp_tested) => {
                                        if (lamp_tested.id == lamp.id) {
                                            trovato = true;
                                            return trovato;
                                        } else return trovato;
                                    });
                                }
                            });
                            //se la lampada non è presente nel logbook, la aggiungo alla lista dell non testate
                            if (!trovato) {
                                rowsNotExec.push({id: lamp.id, desc: lamp.desc, code: lamp.order_code, tipo: (lamp.product_desc.includes('|') ? lamp.product_desc.split('|')[0] : lamp.product_desc), cuName: unit.cu_type + '-' + unit.cu_id});
                            }
                        });
                    }
                });
                doc.autoTable({
                    columns: columnsNotExec,
                    body: rowsNotExec,
                    headStyles :{
                        font: 'Roboto',
                        fontSize: 11,
                        fillColor : [153, 153, 153]
                    },
                    styles: {
                        font: 'Roboto',
                        fontSize: 10,
                    },
                    alternateRowStyles: {fillColor : [202, 202, 202]},
                    tableLineColor: [80, 80, 80],
                    tableLineWidth: 0.1,
                    startY: 80
                });
            }

            doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2), doc.internal.pageSize.height - 40, 70, 20);
            doc.save(table_name);
       },


        //-------------------------------------
        //Find spare parts occurences (integer)
        //-------------------------------------
        findBattOccurences(arr, key) {
            const lookup = {};

            arr.forEach((x) => {
                const val = x[key];
                //verifico se è già presente nella lookup
                if (lookup[val]) {
                    console.log("Trovato valore già presente nella lookup: ", val);
                    if (x.qty != null && x.qty != "" && x.qty != "n.d.") {
                        lookup[val].occurrence += Number(x.qty);
                    } else {
                        lookup[val].occurrence++;
                    }
                } else {
                    //first time seeing this, create the entry
                    lookup[val] = {
                        [key]: val,
                        desc: x.desc,
                        occurrence: (x.qty != null && x.qty != "n.d.") ? Number(x.qty) : 1
                    };
                }
            });
            //convert the lookup object back into an array
            return Object.values(lookup);
        }


    }

}
</script>

<style lang="scss">
  #td_empty{ width: 5%; text-align: left;}
  #td_id{ width: 10%; text-align: left;}
  #td_stato{ width: 5%; text-align: center;}
  #td_desc { width: 20%;  text-align: left;}
  #td_prod { width: 25%; text-align: left;}
  #td_err { width: 15%; text-align: right;}
  #td_note { width: 20%; text-align: center;}

  #div_timestamp{ width: 100%; text-align: left;}
  #div_cent{ width: 100%; text-align: left;}
  #div_test { width: 100%; text-align: left;}
  #div_stato { width: 100%; text-align: center;}
  #div_download { width: 100%; text-align: right;}

  .datatable-body {
    display: block;
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: auto;
  }

  .sticky-header {
    position: fixed;
    // top: 0;
    // width: 100%
  }

  .statusCol {
    width:30%;
  }

  .idCol {
    width: 15%;
  }

  .cuCol {
    width: 15%;
  }

  .dateCol {
    width: 20%;
  }

  .typeCol {
    width: 25%;
  }

  .errorCol {
    width: 35%;
  }


  #tr_note {
      border: none !important;
      display: flex;
      justify-content: flex-end;
      align-items: stretch;
  }
  #iconbutton_note {
      border: none;
      padding: 0%;
      margin: 0%;
  }

.text-widget {
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 15px;
}

.card-header {
    background-color: #ffffff;
}

.alerts-wrapper {
  padding-top: 40px;
}
</style>
